export const categories = [
  { id: 'all', name: 'All Products' },
  { id: 'accessories', name: 'Accessories' },
  { id: 'mutes', name: 'Mutes & Practice' },
  { id: 'instruments', name: 'Instruments' },
  { id: 'sheet-music', name: 'Sheet Music & Digital' },
];

export const products = [
  // ===== FEATURED & BESTSELLERS =====
  {
    id: 1,
    name: 'NoteTurner for ForScore',
    slug: 'noteturner',
    price: 34.99,
    originalPrice: 39.99,
    category: 'accessories',
    image: 'https://static.wixstatic.com/media/4a2ebb_895ee36e15ba4f70aee1a0473dc735c4~mv2.jpg',
    images: [
      'https://static.wixstatic.com/media/4a2ebb_e23927b6240d4ba48f9be12101ef00f8f002.jpg',
      'https://static.wixstatic.com/media/4a2ebb_1edcb446ec0149f6838219bbd82383ae~mv2.jpg',
      'https://static.wixstatic.com/media/4a2ebb_a7f545a80de1472ab20fd68f0797267bf002.jpg',
      'https://static.wixstatic.com/media/4a2ebb_e79ce37c75f14557b67f9b39341f7f1b~mv2.webp',
      'https://static.wixstatic.com/media/4a2ebb_ea2f1768ee41411f8963fa219ac26397~mv2.jpg',
      'https://static.wixstatic.com/media/4a2ebb_1973fcab35cc47e092ed83d3d72ab1ab~mv2.jpg',
      'https://static.wixstatic.com/media/4a2ebb_3c2346f82684487899e3c5f0682c1ad8~mv2.webp'
    ],
    badge: 'BESTSELLER',
    featured: true,
    wixUrl: 'https://www.toneregistry.com/product-page/forscore-page-turner',
    wixProductId: '6bc5bf61-5ab5-c8cf-3c3b-de0fb600a8ef',
    seoTitle: 'NoteTurner Bluetooth Page Turner – Hands-Free Score Navigation',
    description: 'The NoteTurner is a first-of-its-kind Bluetooth page turner designed for saxophone, clarinet, trumpet, Flugelhorn, Trombone, French horn, Guitar, Bass, Accordion, and Bandoneon players. Bluetooth 5.0 is required. Check list of compatible apps.',
    features: ['Bluetooth 5.0', 'Works with most sheet-music apps', 'iPad / Android compatible', 'Screen lock feature', '9+ months battery (high-capacity option)'],
    variants: {
      type: 'NOTETURNER',
      required: true,
      groups: [
        { name: 'INSTRUMENT', options: ['Trumpet / Flugel / French Horn', 'Saxophone / Clarinet', 'Trombone', 'Guitar / Bass Guitar / Accordion / Bandoneon'] },
        { name: 'BATTERY', options: ['Generic Battery (40 Hours of usage)', 'Energizer / ProCell Lithium+ — 9+ months (+$9.99)'] },
      ],
    },
    // Marketing scarcity badge — shown when stockLeft <= 5. Set deliberately
    // low to nudge fence-sitters; admin can change it via Sanity at any time.
    stockLeft: 2,
  },
  {
    id: 2,
    name: 'MuteClip',
    slug: 'muteclip',
    price: 11.99,
    originalPrice: 14.99,
    category: 'accessories',
    image: 'https://static.wixstatic.com/media/4a2ebb_46a74401802747469ac90c062bec6f52~mv2.jpg',
    images: [
      'https://static.wixstatic.com/media/4a2ebb_990aabb1c5b54b9fa504a309700fe54b~mv2.jpg',
      'https://static.wixstatic.com/media/4a2ebb_5efcc848d25e4fd7ba17a09789b33540~mv2.jpg',
      'https://static.wixstatic.com/media/4a2ebb_755cc3e4fa4a47a796b17c0b6471fce8~mv2.jpg',
      'https://static.wixstatic.com/media/4a2ebb_82f4b225d26b4fa88b8afa989c490857~mv2.jpg',
      'https://static.wixstatic.com/media/4a2ebb_451a8a3871d243a4b2f4fb6906878d91~mv2.jpg',
      'https://static.wixstatic.com/media/4a2ebb_a2bfdc7cfe0c4fc3bd392127af7ede30f002.jpg',
      'https://static.wixstatic.com/media/4a2ebb_45998364753a4a5fb14575e15be2a561~mv2.jpg'
    ],
    badge: 'POPULAR',
    featured: true,
    wixUrl: 'https://www.toneregistry.com/product-page/muteclip-x1',
    wixProductId: 'e40d0027-31ac-5151-6830-738c6b8a27e3',
    seoTitle: 'MuteClip – Durable Trumpet Mute Holder Accessory',
    description: 'Keep your mute secure and within reach. Attaches to your music stand or belt for quick access during performances.',
    features: ['Durable construction', 'Universal fit', 'Quick-release design', 'Stand & belt compatible'],
    variants: {
      type: 'Mute Clip',
      options: ['Single', '4 Pack (free box)'],
      required: true,
    },
  },
  {
    id: 3,
    name: 'JiMendez Practice Mute',
    slug: 'practice-mute',
    price: 32.00,
    originalPrice: 40.00,
    category: 'mutes',
    image: 'https://static.wixstatic.com/media/4a2ebb_bdd1713f308d400285f8b07d7224dce6~mv2.jpg',
    images: [
      'https://static.wixstatic.com/media/4a2ebb_7bb7e3bc3982434e9dc6a2b00b998c89~mv2.jpg',
      'https://static.wixstatic.com/media/4a2ebb_bdd1713f308d400285f8b07d7224dce6~mv2.jpg',
      'https://static.wixstatic.com/media/4a2ebb_8c3bf0448b6f41b6b74eae5a67005c71~mv2.png',
      'https://static.wixstatic.com/media/4a2ebb_0276ecf20d7a4c23906b476211dc81d4~mv2.png'
    ],
    badge: 'SALE',
    featured: true,
    wixUrl: 'https://www.toneregistry.com/product-page/jimendez-practice-mute',
    wixProductId: '13a431f7-5ab9-6cd5-210e-e23876abb4a3',
    seoTitle: 'JiMendez Practice Mute – Lightweight Trumpet Practice Tool',
    description: 'Practice anywhere without disturbing others. Excellent sound reduction while maintaining natural resistance.',
    features: ['Lightweight design', 'Natural resistance feel', '25-30 dB reduction', 'Professional quality'],
  },
  {
    id: 4,
    name: 'MuteCap (pack of 5 caps)',
    slug: 'mutecap',
    price: 11.99,
    category: 'accessories',
    image: 'https://static.wixstatic.com/media/4a2ebb_a25ef26f758643f6b503f292354909bb~mv2.png',
    images: [
      'https://static.wixstatic.com/media/4a2ebb_b8fa2a7c3b8744148ec8537f215e142d~mv2.png',
      'https://static.wixstatic.com/media/4a2ebb_ffb0847bcf80458fa35175b3db114fa6~mv2.png',
      'https://static.wixstatic.com/media/4a2ebb_ec98aa08b8f14619aa777f41ce0a924f~mv2.png'
    ],
    wixUrl: 'https://www.toneregistry.com/product-page/mutecap',
    wixProductId: 'ee658c10-ea56-635d-8ca8-e57aaae3c67a',
    seoTitle: 'MuteCap Pack of 5 – Durable Trumpet Mute Caps',
    description: 'Protect your mute investment with quality caps designed to prevent damage.',
    features: ['Pack of 5 caps', 'Universal fit', 'Durable material'],
  },
  {
    id: 5,
    name: 'FingerFlow',
    slug: 'fingerflow',
    price: 34.99,
    category: 'accessories',
    image: 'https://static.wixstatic.com/media/4a2ebb_29d408f980f24d51af5f933e0260cbfa~mv2.png',
    images: [
      'https://static.wixstatic.com/media/4a2ebb_b8fa2a7c3b8744148ec8537f215e142d~mv2.png',
      'https://static.wixstatic.com/media/4a2ebb_29d408f980f24d51af5f933e0260cbfa~mv2.png'
    ],
    featured: true,
    wixUrl: 'https://www.toneregistry.com/product-page/fingerflow',
    wixProductId: '953dbda3-d985-d2a2-26aa-a6ffd24785ba',
    seoTitle: 'FingerFlow – Finger Independence Trainer',
    youtubeUrl: 'https://youtube.com/shorts/GpojC8WcAHY?feature=share',
    description: "FingerFlow trains the half of finger movement most musicians never practise: the negative motion. Just like at the gym — bicep curls build muscle, but the controlled lowering (the negative) builds the OTHER half of strength, control, and tendon resilience. FingerFlow's ergonomic resistance pad forces each finger to work both directions — downstroke AND the controlled upstroke. Train both halves of the movement and you'll feel faster, lighter, and more precise across every passage. Built for trumpet, saxophone, clarinet, piano, and guitar players.",
    features: ['Trains NEGATIVE finger movement (eccentric load)', 'Like the gym — both halves of the motion', 'Builds tendon resilience & precision', 'Ergonomic resistance pad', 'Works for all wind & string instruments', 'Compact, portable'],
  },
  {
    id: 6,
    name: 'The Brass Plank',
    slug: 'brass-plank',
    price: 34.99,
    originalPrice: 39.99,
    category: 'accessories',
    image: 'https://static.wixstatic.com/media/4a2ebb_99eb55f9a9aa4a8e822cbb0e3eedcf04~mv2.jpg',
    images: [
      'https://static.wixstatic.com/media/4a2ebb_7dd27f35145d42f9b4ee5e3f8652a14ef002.jpg',
      'https://static.wixstatic.com/media/4a2ebb_6fb4f69216eb46089f8356b5d5ca75ee~mv2.jpg',
      'https://static.wixstatic.com/media/4a2ebb_ff3848f1cd614983adbd3899e7c9361c~mv2.jpg',
      'https://static.wixstatic.com/media/4a2ebb_dd117d1b3fa34de59581c51c9205e2f9~mv2.jpg',
      'https://static.wixstatic.com/media/4a2ebb_f689e22121d148be8f2f2a38a9ab436c~mv2.jpg',
      'https://static.wixstatic.com/media/4a2ebb_76a57520f85943c3a85fc136bcf2adb1~mv2.png',
      'https://static.wixstatic.com/media/4a2ebb_f99a4ba881c24ab688e85757065fd81d~mv2.jpg',
      'https://static.wixstatic.com/media/4a2ebb_d125ecc2db4b446a8712c74c0e7b4ef4~mv2.jpg'
    ],
    badge: null,
    wixUrl: 'https://www.toneregistry.com/product-page/the-brass-plank',
    wixProductId: 'd9394ba1-3bbb-94ba-2e15-4f3de4c8325b',
    seoTitle: 'The Brass Plank — Portable Condensation Absorber for Brass & Wind Players',
    youtubeUrl: 'https://youtu.be/Cj_GMiqbD8Q',
    videosByLanguage: {
      en: 'https://youtu.be/Cj_GMiqbD8Q',
      es: 'https://youtu.be/O4Tz7rxQWdw',
    },
    description: "Can You Plank Ahead?\n\nThe Brass Plank is the world's first portable condensation absorber (Pat. Pending) — purpose-built for wind and brass players who care about cleanliness, professionalism, and convenience. After 30+ years on stage, I designed The Brass Plank to solve one of brass players' most overlooked challenges: where to drain valves without making a mess.",
    descriptionRich: {
      tagline: 'Because every drop counts.',
      paragraphs: [
        "Meet The Brass Plank — more than just a plank. In an age where cleanliness matters more than ever, I designed a solution for one of brass players' most… drippy challenges: condensation (yes, that kind).",
        "With 30+ years in the music scene, I know the awkward hunt for a \"safe spot\" all too well. Now, whether you're teaching back-to-back lessons or performing with a hundred-piece brass section, you'll be ready.",
        "The Brass Plank is the world's first portable condensation absorber (Pat. Pending), designed for wind and brass players.",
        "Say goodbye to awkward puddles, judgmental stares, and damp rehearsal floors. Stay clean. Stay confident. Plank ahead with The Brass Plank.",
      ],
      pullquote: 'Stay clean. Stay confident. Plank ahead.',
      keyFeatures: [
        { icon: '📚', label: 'Ultra-Compact', body: 'Just 20 mm thick — the size of a book.' },
        { icon: '🌱', label: 'Eco-Friendly', body: 'Made from sustainable materials.' },
        { icon: '⏱️', label: 'Dries in Under 5 Minutes', body: 'Ready for the next set.' },
        { icon: '✋', label: 'Contact-Free', body: 'Mess-free, hygienic design.' },
        { icon: '♻️', label: 'Zero Waste', body: 'No washing, no tossing.' },
        { icon: '⚡', label: 'Easy Assembly', body: 'Set up in seconds, every time.' },
        { icon: '🎺', label: 'All Wind Instruments', body: 'Trumpet, trombone, sax, clarinet — works for all.' },
        { icon: '💰', label: 'Money-Back Guarantee', body: 'Try it risk-free.' },
      ],
    },
    features: ['Ultra-compact 20 mm', 'Eco-friendly materials', 'Dries in <5 minutes', 'Contact-free design', 'Money-back guarantee'],
    outOfStock: false,
  },

  // ===== MUTES =====
  {
    id: 7,
    name: 'Piccolo Mute',
    slug: 'piccolo-mute',
    price: 49.99,
    category: 'mutes',
    image: 'https://static.wixstatic.com/media/4a2ebb_242c8a8e70f54a93a9ae94e48cc398ae~mv2.jpg',
    images: [
      'https://static.wixstatic.com/media/4a2ebb_fdd5c80a575e4f4886f5cc368ef65baa~mv2.jpg',
      'https://static.wixstatic.com/media/4a2ebb_b8fa2a7c3b8744148ec8537f215e142d~mv2.png',
      'https://static.wixstatic.com/media/4a2ebb_a194497adeb742428930df789f0695f5~mv2.jpg'
    ],
    wixUrl: 'https://www.toneregistry.com/product-page/piccolo-mute',
    wixProductId: '1c6d6abb-4b8f-991e-b976-2d04cf90ec92',
    seoTitle: 'Trumpet Piccolo Mute – Precision Sound Control',
    description: 'Specialized mute designed for piccolo trumpet with precision fit.',
    features: ['Piccolo trumpet specific', 'Precision fit', 'Focused tone'],
  },
  {
    id: 8,
    name: 'MuteMute',
    slug: 'mutemute',
    price: 11.99,
    category: 'mutes',
    image: 'https://static.wixstatic.com/media/4a2ebb_bf09eb1878824c309358b64debb726ed~mv2.jpg',
    images: [
      'https://static.wixstatic.com/media/4a2ebb_bf09eb1878824c309358b64debb726ed~mv2.jpg',
      'https://static.wixstatic.com/media/4a2ebb_bf09eb1878824c309358b64debb726ed~mv2.jpg',
      'https://static.wixstatic.com/media/4a2ebb_b8fa2a7c3b8744148ec8537f215e142d~mv2.png',
      'https://static.wixstatic.com/media/4a2ebb_af54006f5a854d37bb80d750aed5e04c~mv2.jpg'
    ],
    wixUrl: 'https://www.toneregistry.com/product-page/mutemute',
    wixProductId: 'b4a1ee57-018f-69eb-8a5b-3ef95cdc3e8e',
    seoTitle: 'MuteMute – Versatile Trumpet Accessory',
    description: 'Versatile mute accessory for various practice scenarios.',
    features: ['Versatile use', 'Sound reduction', 'Easy to use'],
  },
  {
    id: 9,
    name: 'BelloFlex Trumpet Mutes',
    slug: 'belloflex-mute',
    price: 74.99,
    category: 'mutes',
    image: 'https://static.wixstatic.com/media/4a2ebb_36cf09a05d5b433191de707df4130613~mv2.jpg',
    images: [
      'https://static.wixstatic.com/media/4a2ebb_f61cd50ec7144e73b104b7c3e56861eaf002.jpg',
      'https://static.wixstatic.com/media/4a2ebb_1bd80bf331e842cba9ca13dac981a3be~mv2.png',
      'https://static.wixstatic.com/media/4a2ebb_b70be743d3004176803149284e51863ef002.jpg',
      'https://static.wixstatic.com/media/4a2ebb_780df1cd75f949ac86b4226f0d90d829~mv2.jpg',
      'https://static.wixstatic.com/media/4a2ebb_02ac250ba11246e88d2bcb2f5ded1396~mv2.jpeg',
      'https://static.wixstatic.com/media/4a2ebb_c940a90c0dd54ce3afd6b1b5e608948b~mv2.jpeg',
      'https://static.wixstatic.com/media/4a2ebb_b15645f09abf428a93ae8c1d5bfecf90f003.jpg',
      'https://static.wixstatic.com/media/4a2ebb_51fbe0d5508c49a3aead96e62d12f562~mv2.jpeg'
    ],
    badge: 'SALE',
    wixUrl: 'https://www.toneregistry.com/product-page/belloflex-trumpet-cup-mute',
    wixProductId: '2c718418-0646-310c-ed32-4569c124b263',
    seoTitle: 'BelloFlex - Flexible Harmon, Cup & Straight Trumpet Mutes',
    description: "🎺✨ BelloFlex™ is a revolutionary flexible cup mute system designed to adapt seamlessly to any trumpet bell for a perfect, consistent fit every time. Made from high-quality TPU, it combines durability, flexibility, and performance in a way traditional mutes simply cannot match.",
    descriptionRich: {
      tagline: 'One mute. Every bell. No corks. No compromises.',
      paragraphs: [
        "🛡️ Protects Your Instrument — Unlike rigid designs, BelloFlex won't ding, scratch, or damage your bell. Its soft, flexible body conforms naturally to different bell sizes, eliminating the need for corks — no more adjustments, no more parts falling off, and no maintenance headaches.",
        "🎒 Ultra-Portable Design — The lightweight, foldable construction makes BelloFlex incredibly easy to carry. It fits effortlessly into instrument cases, gig bags, or even a jacket pocket.",
        "💪 Built to Last — Despite its flexibility, BelloFlex is exceptionally durable.",
        "🧲 MuteClip Compatible — BelloFlex integrates seamlessly with the MuteClip system, allowing for fast, secure magnetic attachment to your music stand — perfect for quick mute changes during rehearsals and performances.",
        "🎵 Enhanced Playing Experience — Players will notice a more open feel, improved projection, and a consistent tone throughout the instrument's range, making BelloFlex ideal for both practice and live performance.",
        "🎺 Available Models: Cup Mute · Straight Mute · Harmon Mute",
        "💲 Pricing: Standard models $74.99 USD each · Custom color models $99.99 USD each",
        "🎁 Custom Color Bonus — All custom-color mutes include a MuteClip at no additional cost.",
        "🔧 Harmon Mute Package — The Harmon Mute additionally comes with a removable stem and a MuteMute™ sound reducer, so it functions as both a traditional Harmon mute and an effective practice mute.",
      ],
      pullquote: "🚀 One mute. Every bell. No corks. No compromises.",
      keyFeatures: [
        { icon: '🛡️', label: 'Flexible TPU', body: 'Bell-safe — no dents or scratches.' },
        { icon: '🚫', label: 'No Corks', body: 'Zero maintenance, consistent performance.' },
        { icon: '🎒', label: 'Foldable', body: 'Ultra-portable, pocket-ready design.' },
        { icon: '⚖️', label: 'Lightweight', body: 'Yet built to last.' },
        { icon: '🧲', label: 'MuteClip Ready', body: 'Magnetic attachment for fast changes.' },
        { icon: '📢', label: 'Open Response', body: 'Improved projection and tone.' },
        { icon: '🎁', label: 'Custom Color Bonus', body: 'Free MuteClip with every custom-color mute.' },
      ],
    },
    features: ['Flexible TPU — bell-safe', 'Adapts to any bell size', 'No corks · zero maintenance', 'Foldable & ultra-portable', 'MuteClip magnetic compatible'],
    variants: {
      type: 'BELLOFLEX',
      required: true,
      groups: [
        { name: 'MATERIAL', options: ['Black', 'Green (Glow-in-the-Dark)', 'White (Glow-in-the-Dark)'] },
        { name: 'MUTE TYPE', options: ['Cup Mute', 'Harmon Mute', 'Straight Mute'] },
        { name: 'CUSTOM COLOR', options: ['No Custom Color', 'Custom Color + MuteClip'] },
      ],
    },
  },
  {
    id: 10,
    name: 'Nimbus Bucket Mute',
    slug: 'nimbus-bucket-mute',
    price: 75.00,
    category: 'mutes',
    image: 'https://static.wixstatic.com/media/4a2ebb_93744cbe263f44dbb001096c4fa97837~mv2.jpg',
    images: [
      'https://static.wixstatic.com/media/4a2ebb_98a49d1eb5e54a3b9e7ea8768a052f67~mv2.jpg',
      'https://static.wixstatic.com/media/4a2ebb_64e1cfd30de0431ab0161a09cca0e94cf002.jpg',
      'https://static.wixstatic.com/media/4a2ebb_b8fa2a7c3b8744148ec8537f215e142d~mv2.png',
      'https://static.wixstatic.com/media/4a2ebb_9acdf3bb1a6547edbb794e9a20ded812~mv2.jpg',
      'https://static.wixstatic.com/media/4a2ebb_2d1884b9037d44c98da42b2e4bb34b1f~mv2.jpg'
    ],
    wixUrl: 'https://www.toneregistry.com/product-page/nimbus-bucket-mute',
    wixProductId: 'c88471c3-e358-3bec-d50e-83c38460327e',
    seoTitle: 'Nimbus Bucket Mute',
    description: 'Professional bucket mute for warm, subdued tones.',
    features: ['Bucket mute', 'Warm tone', 'Studio quality'],
  },
  {
    id: 11,
    name: 'Cork for Harmon Mute',
    slug: 'cork-harmon-mute',
    price: 9.99,
    category: 'mutes',
    image: 'https://static.wixstatic.com/media/4a2ebb_693db452b044449a969c022a58a2dda7~mv2.jpg',
    images: [
      'https://static.wixstatic.com/media/4a2ebb_693db452b044449a969c022a58a2dda7~mv2.jpg',
      'https://static.wixstatic.com/media/4a2ebb_cab6f1c21a0247a79dfe6e4146f32afa~mv2.jpg',
      'https://static.wixstatic.com/media/4a2ebb_8c5842d075c04baf9d6bf64f041b0b31~mv2.jpg',
      'https://static.wixstatic.com/media/4a2ebb_b8fa2a7c3b8744148ec8537f215e142d~mv2.png',
      'https://static.wixstatic.com/media/4a2ebb_1a08895909aa4e2d823b76092bf44ebf~mv2.jpg'
    ],
    wixUrl: 'https://www.toneregistry.com/product-page/cork-for-harmon-mute',
    wixProductId: '82e5a99f-532d-a2b2-540d-cdb8f2385f21',
    seoTitle: 'Cork for Harmon Mute',
    description: 'Replacement cork for harmon mutes.',
    features: ['Perfect fit', 'Quality cork', 'Easy installation'],
  },

  // ===== SONICLIFT =====
  {
    id: 77,
    name: 'SonicLift Trumpet Support',
    slug: 'soniclift',
    price: 29.99,
    category: 'accessories',
    image: 'https://static.wixstatic.com/media/4a2ebb_a9f8939a1e5f4aaaaa9588c446d46f95~mv2.jpeg',
    images: [
      'https://static.wixstatic.com/media/4a2ebb_a9f8939a1e5f4aaaaa9588c446d46f95~mv2.jpeg',
      'https://static.wixstatic.com/media/4a2ebb_8def40e17ae1417d9e6769e176a9de2c~mv2.jpeg',
      'https://static.wixstatic.com/media/4a2ebb_ec9a198b801f4f40aff36cf8e226ea8df002.jpg'
    ],
    badge: 'NEW',
    wixUrl: 'https://www.toneregistry.com/product-page/soniclift',
    wixProductId: '',
    seoTitle: 'SonicLift Trumpet Support – Ultrasonic Cleaner Protection',
    description: 'Cleaning your trumpet in an ultrasonic tank shouldn\'t come with risk. This support keeps your trumpet safely suspended inside the tank, preventing direct contact with the base and reducing excessive vibration during the cleaning process. Built by a professional musician with over 30 years of experience. Comes in two parts: valve casing holder and bell holder.',
    features: [
      'Keeps trumpet elevated and protected',
      'Reduces exposure to aggressive vibration zones',
      'Helps preserve lacquer, plating, and structural integrity',
      'Designed for real-world use by brass players',
      'Comes in two parts: valve casing holder and bell holder'
    ],
  },

  // ===== SAXOLIFT =====
  {
    id: 78,
    name: 'SaxoLift, Sax Key Riser',
    slug: 'saxolift',
    price: 9.99,
    category: 'accessories',
    image: 'https://static.wixstatic.com/media/4a2ebb_8bb825c63992489997b33aa5bdfc79d4~mv2.jpg',
    images: [
      'https://static.wixstatic.com/media/4a2ebb_8bb825c63992489997b33aa5bdfc79d4~mv2.jpg',
      'https://static.wixstatic.com/media/4a2ebb_1d430a646070447ca87575dec536f1ed~mv2.jpg',
      'https://static.wixstatic.com/media/4a2ebb_56cd63ae660841e48b81f160063a682d~mv2.jpg',
      'https://static.wixstatic.com/media/4a2ebb_e46f2c8933bc487ea47b4ca5bc1886c1~mv2.jpg',
      'https://static.wixstatic.com/media/4a2ebb_9ea55d5e6f274907b69e5641770a3a3f~mv2.jpg'
    ],
    badge: 'NEW',
    featured: true,
    wixUrl: 'https://www.toneregistry.com/product-page/sax-key-riser',
    wixProductId: '',
    seoTitle: 'SaxoLift Sax Key Riser – TPU Left Palm Key Risers for Saxophone',
    description: 'Saxophone Left Palm Key Risers designed to improve comfort, speed, and control for saxophonists of all levels. Made from high-quality TPU, these risers provide the perfect balance of softness, grip, and durability. The ergonomic design reduces finger strain while making left palm key transitions feel more natural and effortless during fast passages and long practice sessions. Available in Black or White/Glow-in-the-Dark Green — the glow version charges under light and emits a subtle green glow in dark environments.',
    features: [
      'Flexible and durable TPU construction',
      'Comfortable ergonomic feel',
      'Improves left-hand palm key accessibility',
      'Easy installation',
      'Lightweight and non-damaging to your instrument',
      'Available in Black or WHITE Glow-in-the-Dark Green',
      'Designed for serious daily use'
    ],
    variants: {
      type: 'BASE COLOR',
      options: ['Black', 'WHITE Glow-in-the-Dark Green'],
      required: true,
    },
  },

  // ===== ACCESSORIES =====
  {
    id: 901,
    name: 'Armis Leather Trumpet Sleeve',
    slug: 'armis-leather-trumpet-sleeve',
    price: 139.99,
    seoTitle: 'Armis Leather Trumpet Sleeve — Steel Bell Protection',
    category: 'accessories',
    badge: 'NEW',
    featured: true,
    instrument: 'trumpet',
    image: 'https://static.wixstatic.com/media/4a2ebb_25f883a781ea4021959eb4e9a9c545dc~mv2.jpg',
    images: [
      'https://static.wixstatic.com/media/4a2ebb_25f883a781ea4021959eb4e9a9c545dc~mv2.jpg',
      'https://static.wixstatic.com/media/4a2ebb_551e9552cea24c1daeb1bae0e322bf48~mv2.jpg',
      'https://static.wixstatic.com/media/4a2ebb_b355096e83324025aa92e3fda6723690~mv2.jpg',
      'https://static.wixstatic.com/media/4a2ebb_bdc0c22b681c414996c33d55f4854e7c~mv2.png',
      'https://static.wixstatic.com/media/4a2ebb_c19783278279413c9fc3f5e1a6fbf284~mv2.jpg'
    ],
    description: "Serious protection for serious musicians. The Armis Leather Trumpet Sleeve is a protective insert — the trumpet slides into the sleeve, and the sleeve slides into your hard trumpet case. It's the extra layer of armour between your horn and the world. After an airline forced me to check my trumpet and my bells arrived damaged, I designed this so it would never happen again. Crafted from 100% genuine leather with a reinforced steel plate built into the bell area to absorb impact and pressure exactly where it matters most. A water-tight zipper adds an extra layer of security from moisture during travel, rehearsals, or daily use.",
    descriptionRich: {
      tagline: 'Serious protection for serious musicians.',
      paragraphs: [
        "After an airline forced me to check my trumpet, my bells arrived damaged. That moment led to the creation of the Armis Leather Trumpet Sleeve — a protective insert that goes inside your hard trumpet case, adding a critical extra layer of protection right where it's needed most.",
        "Crafted from 100% genuine leather, Armis combines durability, elegance, and practical protection in a compact design that slides into your existing case alongside your horn.",
        "At its core is a reinforced steel plate built into the bell area, providing critical protection against impact and pressure — something traditional soft cases simply don't offer.",
        "A water-tight zipper adds an extra layer of security, helping protect your instrument from moisture during travel, rehearsals, or everyday use.",
      ],
      pullquote: 'Designed by a professional with 30+ years on stage.',
      keyFeatures: [
        { icon: '🛡️', label: 'Steel Bell Protection', body: 'Reinforced plate shields the most fragile part of your trumpet.' },
        { icon: '🧳', label: 'Travel-Ready', body: 'Ideal for flights, gigs, and rehearsals.' },
        { icon: '🐄', label: '100% Genuine Leather', body: 'Durable, flexible, built to last.' },
        { icon: '💧', label: 'Water-Tight Zipper', body: 'Added protection from moisture and spills.' },
        { icon: '🎺', label: 'Compact & Lightweight', body: 'Slides into your existing hard case — no bulky second case needed.' },
      ],
    },
    features: ['Protective insert — goes inside your hard case', 'Reinforced steel plate over the bell', '100% genuine leather construction', 'Water-tight zipper', 'Compact & lightweight — no bulky second case', 'Designed by a touring trumpet player'],
    wixUrl: 'https://www.toneregistry.com/product-page/armis-leather-trumpet-sleeve',
  },
  {
    id: 902,
    name: 'Armis BellGuard',
    slug: 'armis-bellguard',
    price: 29.99,
    seoTitle: 'Armis BellGuard — TPU Trumpet Bell Protection',
    category: 'accessories',
    badge: 'NEW',
    featured: true,
    instrument: 'trumpet',
    image: 'https://static.wixstatic.com/media/4a2ebb_4a3a4bc9331640b7b5805f78d4bc68d9~mv2.jpg',
    images: [
      'https://static.wixstatic.com/media/4a2ebb_4a3a4bc9331640b7b5805f78d4bc68d9~mv2.jpg',
      'https://static.wixstatic.com/media/4a2ebb_3a379c52b66043bd8fc2103ddc982202f002.jpg',
      'https://static.wixstatic.com/media/4a2ebb_450b85d8bc2f479fa339e89abe801de2~mv2.jpg',
      'https://static.wixstatic.com/media/4a2ebb_f7c218b4767643a59d749314a76afb99~mv2.jpg',
      'https://static.wixstatic.com/media/4a2ebb_4a2faf58b9914594917fdc7e2b21945c~mv2.jpg'
    ],
    description: '🛡️ Armis BellGuard – TPU Trumpet Protection.\n\nWhen you fly with your instrument, you trust your case to protect it. I did too… until an airline gate-checked my trumpet case — and after landing, two of my bells were crushed. That moment led to the creation of something better.\n\nArmis BellGuard is designed to protect the most vulnerable part of your instrument: the bell. Made from high-quality flexible TPU, it works like a phone case — but for your trumpet. It absorbs impact, disperses pressure, and adds a critical layer of protection exactly where you need it most.',
    descriptionRich: {
      tagline: 'TPU armor for the most fragile part of your instrument.',
      paragraphs: [
        "When you fly with your instrument, you trust your case to protect it. I did too — until an airline gate-checked my trumpet case and after landing, two of my bells were crushed. That moment led to the creation of something better.",
        "Armis BellGuard is designed to protect the most vulnerable part of your instrument: the bell. Made from high-quality flexible TPU, it works like a phone case — but for your trumpet.",
        "It absorbs impact, disperses pressure, and adds a critical layer of protection exactly where you need it most.",
        "The bell isn't just cosmetic — it's your sound, your projection, your voice. One hit during travel can permanently affect your instrument. BellGuard helps prevent that.",
      ],
      pullquote: "Your sound deserves armor.",
      keyFeatures: [
        { icon: '🛡️', label: 'Impact Absorbing', body: 'Flexible, durable, shock-resistant TPU.' },
        { icon: '🎯', label: 'Precision Fit', body: 'Snug & secure — no damage to the finish.' },
        { icon: '⚖️', label: 'Lightweight', body: 'No added bulk in your case.' },
        { icon: '⚡', label: 'Quick On/Off', body: 'Ready when you travel, removable when you play.' },
        { icon: '✈️', label: 'Travel-Ready', body: 'Ideal for flights, tours, and daily transport.' },
      ],
    },
    features: ['Impact-absorbing TPU', 'Precision fit', 'Lightweight & compact', 'Quick on/off', 'Travel-ready'],
    variants: {
      type: 'MODEL TYPE',
      options: [
        'Small Bell 122-125mm (Conn...)',
        'Standard Bell  127mm (Bach, Yamaha LA...)',
        'Large 130mm (Monette LT 2000...)',
        'Xtra Large 134mm (Stomvi Vr2 large bell, etc)',
      ],
      required: true,
    },
    wixUrl: 'https://www.toneregistry.com/product-page/armis-bellguard',
  },

  // ===== ACCESSORIES (continued) =====
  {
    id: 12,
    name: 'BrassGutter',
    slug: 'brassgutter',
    price: 9.99,
    category: 'accessories',
    image: 'https://static.wixstatic.com/media/4a2ebb_f78c4c85fbf548cbb5c0322288bf0391~mv2.jpg',
    images: [
      'https://static.wixstatic.com/media/4a2ebb_b8fa2a7c3b8744148ec8537f215e142d~mv2.png',
      'https://static.wixstatic.com/media/4a2ebb_f78c4c85fbf548cbb5c0322288bf0391~mv2.jpg',
      'https://static.wixstatic.com/media/4a2ebb_7ada184fbc214893b67c7ef93329d8c8~mv2.jpg',
      'https://static.wixstatic.com/media/4a2ebb_c922878c593d42e5907d0a75f8da44b5~mv2.jpg'
    ],
    wixUrl: 'https://www.toneregistry.com/product-page/brassgutter',
    wixProductId: 'c401949c-a039-95a1-6729-e0bb38d1a2a4',
    seoTitle: 'BrassGutter – Trumpet Water Management',
    description: 'Essential brass accessory for water management and instrument protection.',
    features: ['Water management', 'Easy installation', 'Durable design'],
  },
  {
    id: 13,
    name: 'Staff Writter (Pentagram Pen)',
    slug: 'staff-writter',
    price: 11.99,
    category: 'accessories',
    image: 'https://static.wixstatic.com/media/4a2ebb_73aa2660d6ef403bbbd1ad3e3a09b119~mv2.jpg',
    images: [
      'https://static.wixstatic.com/media/4a2ebb_b8fa2a7c3b8744148ec8537f215e142d~mv2.png',
      'https://static.wixstatic.com/media/4a2ebb_73aa2660d6ef403bbbd1ad3e3a09b119~mv2.jpg',
      'https://static.wixstatic.com/media/4a2ebb_ef295e28f43b473cb8705db17766226e~mv2.png',
      'https://static.wixstatic.com/media/4a2ebb_b2dcdbeade094e579c6da9a746006ac7~mv2.png',
      'https://static.wixstatic.com/media/4a2ebb_8f079ff60a8140f5a935ea3c75c7df45~mv2.png'
    ],
    wixUrl: 'https://www.toneregistry.com/product-page/pentagram-pen',
    wixProductId: '09f8e2e8-39af-f53b-e002-bcdcea6c4a77',
    seoTitle: 'Staff Writter Pentagram Pen',
    description: 'Draw perfect staff lines every time with this specialized music notation pen.',
    features: ['5-line staff', 'Smooth ink flow', 'Professional quality'],
  },
  {
    id: 14,
    name: 'GanschTrigger',
    slug: 'ganschtrigger',
    price: 29.99,
    category: 'accessories',
    image: 'https://static.wixstatic.com/media/4a2ebb_9290f10012884343a0044f5c99746249~mv2.png',
    images: [
      'https://static.wixstatic.com/media/4a2ebb_ef731c74fe044a9e94a5f2c8acab1508~mv2.png',
      'https://static.wixstatic.com/media/4a2ebb_a3d9eae179a14bbd879116bb12fab4a9~mv2.png',
      'https://static.wixstatic.com/media/4a2ebb_b8fa2a7c3b8744148ec8537f215e142d~mv2.png',
      'https://static.wixstatic.com/media/4a2ebb_9290f10012884343a0044f5c99746249~mv2.png',
      'https://static.wixstatic.com/media/4a2ebb_eaff07293ba144e6a33e528cfa5e9122f002.jpg',
      'https://static.wixstatic.com/media/4a2ebb_7a2b051535214810ac880d437ad99e46~mv2.jpg',
      'https://static.wixstatic.com/media/4a2ebb_7d7efaeee05f47e6b309742795d7ad94~mv2.jpg'
    ],
    wixUrl: 'https://www.toneregistry.com/product-page/ganschtrigger',
    wixProductId: 'b4f4c619-6a49-b129-8496-5469a2bd3ab9',
    seoTitle: 'GanschTrigger – Finger Stabilizer',
    description: 'Innovative finger stabilizer for improved accuracy and technique.',
    features: ['Finger stabilization', 'Improved accuracy', 'Easy installation'],
  },
  {
    id: 15,
    name: 'Trumpet Visualizer',
    slug: 'trumpet-visualizer',
    price: 11.99,
    category: 'accessories',
    image: 'https://static.wixstatic.com/media/4a2ebb_1fa9585d293a4c3aae8d07f8a5911ff5~mv2.jpg',
    images: [
      'https://static.wixstatic.com/media/4a2ebb_b8fa2a7c3b8744148ec8537f215e142d~mv2.png'
    ],
    wixUrl: 'https://www.toneregistry.com/product-page/trumpet-visualizer-1',
    wixProductId: '4f83b78b-7264-f005-21d5-d8e535c5fa1f',
    seoTitle: 'Trumpet Visualizer – Embouchure Training Tool',
    description: 'Clear training tool for embouchure development.',
    features: ['Clear design', 'Embouchure training', 'Technique improvement'],
  },
  {
    id: 16,
    name: 'BrassBlast',
    slug: 'brassblast',
    price: 12.99,
    category: 'accessories',
    image: 'https://static.wixstatic.com/media/4a2ebb_90d7daaad2504a4b9a991175258775b4~mv2.jpg',
    images: [
      'https://static.wixstatic.com/media/4a2ebb_b8fa2a7c3b8744148ec8537f215e142d~mv2.png',
      'https://static.wixstatic.com/media/4a2ebb_90d7daaad2504a4b9a991175258775b4~mv2.jpg',
      'https://static.wixstatic.com/media/4a2ebb_a78f5bdeb855434dac42d46655321f78~mv2.jpg',
      'https://static.wixstatic.com/media/4a2ebb_2884fbcee7564c0c8ff406ff3c4ff1b9~mv2.jpg'
    ],
    wixUrl: 'https://www.toneregistry.com/product-page/brassblast',
    wixProductId: '67c4f05c-44dd-6518-83c5-e6b455011421',
    seoTitle: 'BrassBlast – Brass Cleaning Tool',
    description: 'Keep your brass instrument clean and shiny.',
    features: ['Deep cleaning', 'Safe for brass', 'Easy to use'],
  },
  {
    id: 17,
    name: 'Trumpet O-rings for Slides',
    slug: 'trumpet-o-rings',
    price: 6.00,
    category: 'accessories',
    image: 'https://static.wixstatic.com/media/4a2ebb_e68a24a593d64e00af71e9e1c4f0f82e~mv2.jpg',
    images: [
      'https://static.wixstatic.com/media/4a2ebb_b8fa2a7c3b8744148ec8537f215e142d~mv2.png',
      'https://static.wixstatic.com/media/4a2ebb_e68a24a593d64e00af71e9e1c4f0f82e~mv2.jpg'
    ],
    wixUrl: 'https://www.toneregistry.com/product-page/trumpet-o-rings-for-slides',
    wixProductId: '3bbfd28d-7a6e-c627-7181-83b8635fd35c',
    seoTitle: 'Trumpet O-rings for Slides',
    description: 'Replacement o-rings for trumpet slides.',
    features: ['Perfect fit', 'Durable rubber', 'Multiple sizes'],
  },
  {
    id: 18,
    name: 'Water Key Tip Cover',
    slug: 'water-key-tip-cover',
    price: 2.50,
    category: 'accessories',
    image: 'https://static.wixstatic.com/media/4a2ebb_f5521aea9711405098224a29e3ae92bd~mv2.jpg',
    images: [
      'https://static.wixstatic.com/media/4a2ebb_dedc3649740d4b78a48e427a9cee7eb7~mv2.jpg',
      'https://static.wixstatic.com/media/4a2ebb_b8fa2a7c3b8744148ec8537f215e142d~mv2.png',
      'https://static.wixstatic.com/media/4a2ebb_f5521aea9711405098224a29e3ae92bd~mv2.jpg'
    ],
    wixUrl: 'https://www.toneregistry.com/product-page/water-key-tip-cover-fits-yamaha-bach-most-trpts',
    wixProductId: '8394495d-6a3e-9292-ac91-02ec58d9ac03',
    seoTitle: 'Water Key Tip Cover – Fits Yamaha, Bach & Most Trumpets',
    description: 'Protective cover for water key tips.',
    features: ['Universal fit', 'Yamaha compatible', 'Bach compatible'],
  },
  {
    id: 19,
    name: 'NeoCap Mouthpiece Pouch',
    slug: 'neocap-pouch',
    price: 12.99,
    category: 'accessories',
    image: 'https://static.wixstatic.com/media/4a2ebb_bc7ea1b9192d48fa8dd5b95406093f81~mv2.jpg',
    images: [
      'https://static.wixstatic.com/media/4a2ebb_084d2f6323794a9dab480223328525db~mv2.jpg',
      'https://static.wixstatic.com/media/4a2ebb_b8fa2a7c3b8744148ec8537f215e142d~mv2.png',
      'https://static.wixstatic.com/media/4a2ebb_bb5f36f6193f49939268eef6a47e7101~mv2.jpg'
    ],
    wixUrl: 'https://www.toneregistry.com/product-page/neocap',
    wixProductId: '594fe454-8539-e5da-4fb2-3c41ff6fc78d',
    seoTitle: 'NeoCap Mouthpiece Pouch',
    description: 'Protective pouch for mouthpiece storage and transport.',
    features: ['Cushioned protection', 'Portable design', 'Multiple mouthpieces'],
  },
  {
    id: 20,
    name: 'Pencil Holder',
    slug: 'pencil-holder',
    price: 5.99,
    category: 'accessories',
    image: 'https://static.wixstatic.com/media/4a2ebb_305a7a658d9c41b88665afc4ab59bfeb~mv2.jpg',
    images: [
      'https://static.wixstatic.com/media/4a2ebb_2031768e94874495b2dd14f2afe242e8~mv2.png',
      'https://static.wixstatic.com/media/4a2ebb_b8fa2a7c3b8744148ec8537f215e142d~mv2.png',
      'https://static.wixstatic.com/media/4a2ebb_305a7a658d9c41b88665afc4ab59bfeb~mv2.jpg'
    ],
    wixUrl: 'https://www.toneregistry.com/product-page/pencil-holder',
    wixProductId: '82960331-19e2-59f3-ebb1-85422ba01e91',
    seoTitle: 'Pencil Holder for Music Stand',
    description: 'Convenient pencil holder for your music stand.',
    features: ['Easy attachment', 'Universal fit', 'Durable design'],
  },
  {
    id: 21,
    name: 'Glow in the Dark Cap for K&M Stand',
    slug: 'glow-cap-km-stand',
    price: 1.99,
    category: 'accessories',
    image: 'https://static.wixstatic.com/media/4a2ebb_1bab0480b4a3447d873c88c586d55d3b~mv2.jpg',
    images: [
      'https://static.wixstatic.com/media/4a2ebb_1bab0480b4a3447d873c88c586d55d3b~mv2.jpg',
      'https://static.wixstatic.com/media/4a2ebb_b8fa2a7c3b8744148ec8537f215e142d~mv2.png',
      'https://static.wixstatic.com/media/4a2ebb_eb7e83bdc74c432098fddb78f78b1e39f003.jpg'
    ],
    wixUrl: 'https://www.toneregistry.com/product-page/glow-in-the-dark-cap-for-k-m-stand',
    wixProductId: '1074f9be-a1d5-5087-5fc3-186588e69710',
    seoTitle: 'Glow in the Dark Cap for K&M Stand',
    description: 'Find your stand in the dark during performances.',
    features: ['Glow in dark', 'K&M compatible', 'Easy to install'],
  },
  {
    id: 22,
    name: 'TromBuddy',
    slug: 'trombuddy',
    price: 24.99,
    category: 'accessories',
    image: 'https://static.wixstatic.com/media/4a2ebb_05ddd5e7a97b48a4a138ebefaf87af87~mv2.jpg',
    images: [
      'https://static.wixstatic.com/media/4a2ebb_b8fa2a7c3b8744148ec8537f215e142d~mv2.png'
    ],
    wixUrl: 'https://www.toneregistry.com/product-page/trombone-holder',
    wixProductId: '8bea1ace-5918-0a55-1757-9f3511e72e39',
    seoTitle: 'TromBuddy – Trombone Holder',
    description: 'Secure holder for your trombone.',
    features: ['Secure grip', 'Easy access', 'Portable'],
  },
  {
    id: 23,
    name: 'Mouthpiece Holder',
    slug: 'mouthpiece-holder',
    price: 15.99,
    category: 'accessories',
    image: 'https://static.wixstatic.com/media/4a2ebb_5b387accf07e436396aeb9515c941b53~mv2.png',
    images: [
      'https://static.wixstatic.com/media/4a2ebb_9898f4c598a24bb390020de9acaf7f84~mv2.png',
      'https://static.wixstatic.com/media/4a2ebb_b8fa2a7c3b8744148ec8537f215e142d~mv2.png'
    ],
    wixUrl: 'https://www.toneregistry.com/product-page/mouthpiece-holder',
    wixProductId: '6b249762-eebd-cadb-fa11-f5778c463888',
    seoTitle: 'Mouthpiece Holder',
    description: 'Keep your mouthpiece secure and accessible.',
    features: ['Secure hold', 'Multiple sizes', 'Durable'],
  },
  {
    id: 24,
    name: 'Slide Rubber Bands',
    slug: 'slide-rubber-bands',
    price: 12.99,
    category: 'accessories',
    image: 'https://static.wixstatic.com/media/4a2ebb_1dff499edab443f287c5161a00c1086b~mv2.png',
    images: [
      'https://static.wixstatic.com/media/4a2ebb_b8fa2a7c3b8744148ec8537f215e142d~mv2.png',
      'https://static.wixstatic.com/media/4a2ebb_1dff499edab443f287c5161a00c1086b~mv2.png'
    ],
    wixUrl: 'https://www.toneregistry.com/product-page/slide-rubber-bands',
    wixProductId: '2ff820d6-8bda-d347-074e-fe0eabf0aa6f',
    seoTitle: 'Slide Rubber Bands',
    description: 'Quality rubber bands for trumpet slides.',
    features: ['Durable', 'Multiple sizes', 'Easy to use'],
  },
  {
    id: 25,
    name: 'BuzzTone',
    slug: 'buzztone',
    price: 8.00,
    originalPrice: 15.99,
    category: 'accessories',
    image: 'https://static.wixstatic.com/media/4a2ebb_cefe31da3a914fbfa38d013ae910300f~mv2.png',
    images: [
      'https://static.wixstatic.com/media/4a2ebb_2ea21b5f59464af1a9f71ddaceb122c9~mv2.png',
      'https://static.wixstatic.com/media/4a2ebb_128c41f5708d441ea56119b87a6081d4~mv2.png',
      'https://static.wixstatic.com/media/4a2ebb_b8fa2a7c3b8744148ec8537f215e142d~mv2.png',
      'https://static.wixstatic.com/media/4a2ebb_cefe31da3a914fbfa38d013ae910300f~mv2.png',
      'https://static.wixstatic.com/media/4a2ebb_408b37691c2749328e10c61ea88c79e5~mv2.png'
    ],
    badge: 'SALE',
    wixUrl: 'https://www.toneregistry.com/product-page/buzzing-extension',
    wixProductId: '88db4564-a483-c434-9023-9937ea27bf80',
    seoTitle: 'BuzzTone – Buzzing Extension',
    description: 'Improve your buzzing technique with this extension.',
    features: ['Buzzing practice', 'Easy to use', 'Portable'],
  },
  {
    id: 26,
    name: 'Yamaha Personal Studio for Trumpet',
    slug: 'yamaha-personal-studio',
    price: 35.00,
    category: 'accessories',
    image: 'https://static.wixstatic.com/media/4a2ebb_67f744bb018e439c9b042b47f1d931c6~mv2.png',
    images: [
      'https://static.wixstatic.com/media/4a2ebb_b8fa2a7c3b8744148ec8537f215e142d~mv2.png'
    ],
    wixUrl: 'https://www.toneregistry.com/product-page/yamaha-personal-studio-for-trumpet',
    wixProductId: 'b9a3672e-573a-ad41-24cb-f911aa97cd67',
    seoTitle: 'Yamaha Personal Studio for Trumpet',
    description: 'Official Yamaha practice system for silent practice.',
    features: ['Yamaha quality', 'Silent practice', 'Portable design'],
  },

  // ===== CASES =====
  {
    id: 27,
    name: 'GL Trumpet Case',
    slug: 'gl-trumpet-case',
    price: 275.00,
    originalPrice: 350.00,
    category: 'accessories',
    image: 'https://static.wixstatic.com/media/4a2ebb_1d709fe3e2e14ebeab727edf01e100d0~mv2.jpg',
    badge: 'SALE',
    wixUrl: 'https://www.toneregistry.com/product-page/gl-trumpet-case',
    wixProductId: 'c8e00738-81b5-4e80-738b-7681ed246698',
    seoTitle: 'GL Trumpet Case – Protective Hard Case',
    description: 'Premium hard case with excellent protection.',
    features: ['Hard case', 'Premium protection', 'Storage pockets'],
  },
  {
    id: 28,
    name: 'Yamaha Double Case',
    slug: 'yamaha-double-case',
    price: 399.00,
    category: 'accessories',
    image: 'https://static.wixstatic.com/media/4a2ebb_be7b00f167294023aab2c13f4632037d~mv2.jpg',
    wixUrl: 'https://www.toneregistry.com/product-page/yamaha-double-case',
    wixProductId: '37f8f8d7-267a-cc7c-9a89-f7e760774ff3',
    seoTitle: 'Yamaha Double Trumpet Case',
    description: 'Official Yamaha case for carrying two trumpets.',
    features: ['Holds 2 trumpets', 'Yamaha quality', 'Secure fit'],
  },

  // ===== INSTRUMENTS =====
  {
    id: 30,
    name: 'P Mauriat PMT-75 Ti x Cu',
    slug: 'p-mauriat-pmt75',
    price: 2999.00,
    originalPrice: 3500.00,
    category: 'instruments',
    image: 'https://static.wixstatic.com/media/4a2ebb_ef662d23a1c6411e91e439488580b52e~mv2.png',
    badge: 'PREMIUM',
    wixUrl: 'https://www.toneregistry.com/product-page/p-mauriat-pmt-75-ti-x-cu',
    wixProductId: '0f1d8627-fbb4-8cff-8cb3-f922c2d7949c',
    seoTitle: 'P Mauriat PMT-75 Ti x Cu Trumpet',
    description: 'Professional-grade trumpet with titanium and copper construction.',
    features: ['Ti x Cu construction', 'Professional grade', 'Exceptional tone'],
  },
  {
    id: 31,
    name: 'Bach Stradivarius 229 C Trumpet',
    slug: 'bach-strad-229c',
    price: 2999.00,
    category: 'instruments',
    image: 'https://static.wixstatic.com/media/4a2ebb_d9ee5fff16054fabb85249c50d24daa9~mv2.jpg',
    images: [
      'https://static.wixstatic.com/media/4a2ebb_3191aad0e81f4f12bb2a9494fa9a9271~mv2.jpg',
      'https://static.wixstatic.com/media/4a2ebb_9b2f1d0fec4749ffbafaa32c6a8020d5~mv2.jpg',
      'https://static.wixstatic.com/media/4a2ebb_b8fa2a7c3b8744148ec8537f215e142d~mv2.png',
      'https://static.wixstatic.com/media/4a2ebb_0b92531a50994879975bbccf8a030efe~mv2.jpg',
      'https://static.wixstatic.com/media/4a2ebb_098ed927b0ab447e84aba62bb9c8e47c~mv2.jpg',
      'https://static.wixstatic.com/media/4a2ebb_0f875641c68b4f9e9f67a79fecbbd2a5~mv2.jpg',
      'https://static.wixstatic.com/media/4a2ebb_9626aa2a43e3462a851337c15fd75087~mv2.jpg'
    ],
    badge: 'PREMIUM',
    wixUrl: 'https://www.toneregistry.com/product-page/bach-stradivarius-229-c-trumpet-with-original-sterling-silver',
    wixProductId: '7bac09db-3ac0-aa30-5025-0a1a5acd17a0',
    seoTitle: 'Bach Stradivarius 229 C Trumpet with Sterling Silver Bell',
    description: 'Legendary Bach quality with original sterling silver bell.',
    features: ['Sterling silver bell', 'C trumpet', 'Legendary tone'],
  },

  // ===== SHEET MUSIC - REAL BOOKS IN C =====
  {
    id: 33,
    name: 'The Real Christmas Book in C',
    slug: 'real-christmas-book-c',
    price: 9.99,
    category: 'sheet-music',
    image: 'https://static.wixstatic.com/media/4a2ebb_1ce815e9554d4b408590139ca4de9e61~mv2.png',
    images: [
      'https://static.wixstatic.com/media/4a2ebb_b8fa2a7c3b8744148ec8537f215e142d~mv2.png',
      'https://static.wixstatic.com/media/4a2ebb_c2939fa82b5a495d915209909f032528~mv2.jpeg',
      'https://static.wixstatic.com/media/4a2ebb_9fb383df343e498aa2c69f6a3c566331~mv2.png',
      'https://static.wixstatic.com/media/4a2ebb_32dd91d7db6f4f04855eb5be47c1af07f002.jpg'
    ],
    videos: ['https://video.wixstatic.com/video/4a2ebb_32dd91d7db6f4f04855eb5be47c1af07/1080p/mp4/file.mp4'],
    wixUrl: 'https://www.toneregistry.com/product-page/the-real-christmas-book-in-c',
    wixProductId: 'b3322479-50b5-2685-05af-9d01070532d0',
    seoTitle: 'The Real Christmas Book in C (Indexed ForScore)',
    description: 'Holiday jazz standards collection, professionally indexed for ForScore.',
    features: ['forScore indexed file (.4sc)', 'Opens in forScore only', 'Instant download'],
  },
  {
    id: 34,
    name: 'Real Book Vol. 1 in C',
    slug: 'real-book-vol-1-c',
    price: 9.99,
    category: 'sheet-music',
    image: 'https://static.wixstatic.com/media/4a2ebb_188f22e62e6c40318f7bab7d982227c1~mv2.jpg',
    images: [
      'https://static.wixstatic.com/media/4a2ebb_188f22e62e6c40318f7bab7d982227c1~mv2.jpg',
      'https://static.wixstatic.com/media/4a2ebb_b8fa2a7c3b8744148ec8537f215e142d~mv2.png',
      'https://static.wixstatic.com/media/4a2ebb_32dd91d7db6f4f04855eb5be47c1af07f002.jpg'
    ],
    videos: ['https://video.wixstatic.com/video/4a2ebb_32dd91d7db6f4f04855eb5be47c1af07/1080p/mp4/file.mp4'],
    wixUrl: 'https://www.toneregistry.com/product-page/real-book-vol-1-in-c-indexed-forscore',
    wixProductId: 'be4a3f69-2c29-ad74-2d0a-2625c4e75f37',
    seoTitle: 'Real Book Vol. 1 in C (Indexed ForScore)',
    description: 'Essential jazz standards with ForScore indexing for quick navigation.',
    features: ['forScore indexed file (.4sc)', 'Opens in forScore only', 'Jazz standards'],
  },
  {
    id: 35,
    name: 'Real Book Vol. 2 in C',
    slug: 'real-book-vol-2-c',
    price: 9.99,
    category: 'sheet-music',
    image: 'https://static.wixstatic.com/media/4a2ebb_c058d8f162c74f6a97fb1827eb247d78~mv2.jpg',
    images: [
      'https://static.wixstatic.com/media/4a2ebb_c058d8f162c74f6a97fb1827eb247d78~mv2.jpg',
      'https://static.wixstatic.com/media/4a2ebb_b8fa2a7c3b8744148ec8537f215e142d~mv2.png',
      'https://static.wixstatic.com/media/4a2ebb_32dd91d7db6f4f04855eb5be47c1af07f002.jpg'
    ],
    videos: ['https://video.wixstatic.com/video/4a2ebb_32dd91d7db6f4f04855eb5be47c1af07/1080p/mp4/file.mp4'],
    wixUrl: 'https://www.toneregistry.com/product-page/real-book-vol-2-in-c-indexed-forscore',
    wixProductId: '2594c839-4579-fe51-ea88-a9ba9b1d3087',
    seoTitle: 'Real Book Vol. 2 in C (Indexed ForScore)',
    description: 'More jazz standards with ForScore indexing.',
    features: ['forScore indexed file (.4sc)', 'Opens in forScore only', 'Jazz standards'],
  },
  {
    id: 36,
    name: 'Real Book Vol. 3 in C',
    slug: 'real-book-vol-3-c',
    price: 9.99,
    category: 'sheet-music',
    image: 'https://static.wixstatic.com/media/4a2ebb_f29d6c8a81fe40de8abcf3965a691c88~mv2.jpg',
    images: [
      'https://static.wixstatic.com/media/4a2ebb_b8fa2a7c3b8744148ec8537f215e142d~mv2.png',
      'https://static.wixstatic.com/media/4a2ebb_c2939fa82b5a495d915209909f032528~mv2.jpeg',
      'https://static.wixstatic.com/media/4a2ebb_32dd91d7db6f4f04855eb5be47c1af07f002.jpg'
    ],
    videos: ['https://video.wixstatic.com/video/4a2ebb_32dd91d7db6f4f04855eb5be47c1af07/1080p/mp4/file.mp4'],
    wixUrl: 'https://www.toneregistry.com/product-page/copy-of-real-book-vol-3-in-c-indexed-forscore',
    wixProductId: 'aacd07e5-9e57-e676-25a0-e5606549e075',
    seoTitle: 'Real Book Vol. 3 in C (Indexed ForScore)',
    description: 'Jazz standards volume 3 with ForScore indexing.',
    features: ['forScore indexed file (.4sc)', 'Opens in forScore only', 'Jazz standards'],
  },
  {
    id: 37,
    name: 'The New Real Book Vol. 1 in C',
    slug: 'new-real-book-vol-1-c',
    price: 9.99,
    category: 'sheet-music',
    image: 'https://static.wixstatic.com/media/4a2ebb_cc7f79c2327042dfb14f2ac34e3f9f78~mv2.png',
    images: [
      'https://static.wixstatic.com/media/4a2ebb_cc7f79c2327042dfb14f2ac34e3f9f78~mv2.png',
      'https://static.wixstatic.com/media/4a2ebb_b8fa2a7c3b8744148ec8537f215e142d~mv2.png',
      'https://static.wixstatic.com/media/4a2ebb_32dd91d7db6f4f04855eb5be47c1af07f002.jpg'
    ],
    videos: ['https://video.wixstatic.com/video/4a2ebb_32dd91d7db6f4f04855eb5be47c1af07/1080p/mp4/file.mp4'],
    wixUrl: 'https://www.toneregistry.com/product-page/the-new-real-book-vol-1-in-c-indexed-forscore',
    wixProductId: '81df81d6-f726-a7dd-bfaa-5a3375be8af6',
    seoTitle: 'The New Real Book Vol. 1 in C (Indexed ForScore)',
    description: 'The New Real Book with ForScore indexing.',
    features: ['forScore indexed file (.4sc)', 'Opens in forScore only', 'Modern standards'],
  },
  {
    id: 38,
    name: 'The New Real Book Vol. 2 in C',
    slug: 'new-real-book-vol-2-c',
    price: 9.99,
    category: 'sheet-music',
    image: 'https://cdn.sanity.io/images/5mllso8r/production/cafe38c9845efde6b5bead933b778dfd93028ad7-1170x1493.jpg',
    images: [
      'https://static.wixstatic.com/media/4a2ebb_b8fa2a7c3b8744148ec8537f215e142d~mv2.png',
      'https://static.wixstatic.com/media/4a2ebb_32dd91d7db6f4f04855eb5be47c1af07f002.jpg',
      'https://cdn.sanity.io/images/5mllso8r/production/cafe38c9845efde6b5bead933b778dfd93028ad7-1170x1493.jpg'
    ],
    videos: ['https://video.wixstatic.com/video/4a2ebb_32dd91d7db6f4f04855eb5be47c1af07/1080p/mp4/file.mp4'],
    wixUrl: 'https://www.toneregistry.com/product-page/the-new-real-book-vol-2-in-c-indexed-forscore',
    wixProductId: '9c66594b-dbf5-2a7e-692f-4ff064a420c1',
    seoTitle: 'The New Real Book Vol. 2 in C (Indexed ForScore)',
    description: 'The New Real Book Vol. 2 with ForScore indexing.',
    features: ['forScore indexed file (.4sc)', 'Opens in forScore only', 'Modern standards'],
  },
  {
    id: 39,
    name: 'The New Real Book Vol. 3 in C',
    slug: 'new-real-book-vol-3-c',
    price: 9.99,
    category: 'sheet-music',
    image: 'https://static.wixstatic.com/media/4a2ebb_7dc127ec1bb944699960c2f928771764~mv2.jpg',
    images: [
      'https://static.wixstatic.com/media/4a2ebb_b8fa2a7c3b8744148ec8537f215e142d~mv2.png',
      'https://static.wixstatic.com/media/4a2ebb_7dc127ec1bb944699960c2f928771764~mv2.jpg',
      'https://static.wixstatic.com/media/4a2ebb_32dd91d7db6f4f04855eb5be47c1af07f002.jpg'
    ],
    videos: ['https://video.wixstatic.com/video/4a2ebb_32dd91d7db6f4f04855eb5be47c1af07/1080p/mp4/file.mp4'],
    wixUrl: 'https://www.toneregistry.com/product-page/the-new-real-book-vol-3-in-c-indexed-forscore',
    wixProductId: 'd753f8b3-9836-8d60-8d9d-b551b71c9290',
    seoTitle: 'The New Real Book Vol. 3 in C (Indexed ForScore)',
    description: 'The New Real Book Vol. 3 with ForScore indexing.',
    features: ['forScore indexed file (.4sc)', 'Opens in forScore only', 'Modern standards'],
  },

  // ===== SHEET MUSIC - REAL BOOKS IN Bb =====
  {
    id: 40,
    name: 'Real Book Vol. 1 in Bb',
    slug: 'real-book-vol-1-bb',
    price: 9.99,
    category: 'sheet-music',
    image: 'https://static.wixstatic.com/media/4a2ebb_d298f56cf7e6438281a12fe4f6b35a7a~mv2.jpeg',
    images: [
      'https://static.wixstatic.com/media/4a2ebb_d298f56cf7e6438281a12fe4f6b35a7a~mv2.jpeg',
      'https://static.wixstatic.com/media/4a2ebb_b8fa2a7c3b8744148ec8537f215e142d~mv2.png',
      'https://static.wixstatic.com/media/4a2ebb_32dd91d7db6f4f04855eb5be47c1af07f002.jpg'
    ],
    videos: ['https://video.wixstatic.com/video/4a2ebb_32dd91d7db6f4f04855eb5be47c1af07/1080p/mp4/file.mp4'],
    wixUrl: 'https://www.toneregistry.com/product-page/real-book-vol-1-in-bb-indexed',
    wixProductId: '85d7361a-ad72-cde5-fc73-2301ab7266a5',
    seoTitle: 'Real Book Vol. 1 in Bb (Indexed ForScore)',
    description: 'Jazz standards in Bb for trumpet players.',
    features: ['forScore indexed file (.4sc)', 'Opens in forScore only', 'Bb transposition'],
  },
  {
    id: 41,
    name: 'Real Book Vol. 2 in Bb',
    slug: 'real-book-vol-2-bb',
    price: 9.99,
    category: 'sheet-music',
    image: 'https://static.wixstatic.com/media/4a2ebb_7ef3ae892f9c4b69b01f7a5457e19123~mv2.jpg',
    images: [
      'https://static.wixstatic.com/media/4a2ebb_7ef3ae892f9c4b69b01f7a5457e19123~mv2.jpg',
      'https://static.wixstatic.com/media/4a2ebb_b8fa2a7c3b8744148ec8537f215e142d~mv2.png',
      'https://static.wixstatic.com/media/4a2ebb_32dd91d7db6f4f04855eb5be47c1af07f002.jpg'
    ],
    videos: ['https://video.wixstatic.com/video/4a2ebb_32dd91d7db6f4f04855eb5be47c1af07/1080p/mp4/file.mp4'],
    wixUrl: 'https://www.toneregistry.com/product-page/real-book-vol-2-in-bb-indexed',
    wixProductId: '91a9debc-a0f5-7779-5cd6-ca8627f63320',
    seoTitle: 'Real Book Vol. 2 in Bb (Indexed ForScore)',
    description: 'Jazz standards Vol. 2 in Bb.',
    features: ['forScore indexed file (.4sc)', 'Opens in forScore only', 'Bb transposition'],
  },
  {
    id: 42,
    name: 'Real Book Vol. 3 in Bb',
    slug: 'real-book-vol-3-bb',
    price: 9.99,
    category: 'sheet-music',
    image: 'https://static.wixstatic.com/media/4a2ebb_71094d8bcc964e3391cbc2fe62d5a4fd~mv2.jpg',
    images: [
      'https://static.wixstatic.com/media/4a2ebb_b8fa2a7c3b8744148ec8537f215e142d~mv2.png',
      'https://static.wixstatic.com/media/4a2ebb_71094d8bcc964e3391cbc2fe62d5a4fd~mv2.jpg',
      'https://static.wixstatic.com/media/4a2ebb_32dd91d7db6f4f04855eb5be47c1af07f002.jpg'
    ],
    videos: ['https://video.wixstatic.com/video/4a2ebb_32dd91d7db6f4f04855eb5be47c1af07/1080p/mp4/file.mp4'],
    wixUrl: 'https://www.toneregistry.com/product-page/real-book-vol-3-in-bb-indexed-forscore',
    wixProductId: '91093dbf-8420-87f2-b6a1-81834cc1247c',
    seoTitle: 'Real Book Vol. 3 in Bb (Indexed ForScore)',
    description: 'Jazz standards Vol. 3 in Bb.',
    features: ['forScore indexed file (.4sc)', 'Opens in forScore only', 'Bb transposition'],
  },
  {
    id: 43,
    name: 'The New Real Book Vol. 1 in Bb',
    slug: 'new-real-book-vol-1-bb',
    price: 9.99,
    category: 'sheet-music',
    image: 'https://static.wixstatic.com/media/4a2ebb_4f8bbd56048f419b8b8bdbf6415a21bb~mv2.png',
    images: [
      'https://static.wixstatic.com/media/4a2ebb_4f8bbd56048f419b8b8bdbf6415a21bb~mv2.png',
      'https://static.wixstatic.com/media/4a2ebb_b8fa2a7c3b8744148ec8537f215e142d~mv2.png',
      'https://static.wixstatic.com/media/4a2ebb_32dd91d7db6f4f04855eb5be47c1af07f002.jpg'
    ],
    videos: ['https://video.wixstatic.com/video/4a2ebb_32dd91d7db6f4f04855eb5be47c1af07/1080p/mp4/file.mp4'],
    wixUrl: 'https://www.toneregistry.com/product-page/the-new-real-book-vol-1-in-bb',
    wixProductId: '2dc1ae0f-0b94-62a4-5567-75a5fb6e0510',
    seoTitle: 'The New Real Book Vol. 1 in Bb (Indexed ForScore)',
    description: 'The New Real Book in Bb transposition.',
    features: ['forScore indexed file (.4sc)', 'Opens in forScore only', 'Bb transposition'],
  },
  {
    id: 44,
    name: 'The New Real Book Vol. 2 in Bb',
    slug: 'new-real-book-vol-2-bb',
    price: 9.99,
    category: 'sheet-music',
    image: 'https://static.wixstatic.com/media/4a2ebb_25cb1f06bf4c44d0bcf72e4f61e100b2~mv2.jpg',
    images: [
      'https://static.wixstatic.com/media/4a2ebb_25cb1f06bf4c44d0bcf72e4f61e100b2~mv2.jpg',
      'https://static.wixstatic.com/media/4a2ebb_b8fa2a7c3b8744148ec8537f215e142d~mv2.png',
      'https://static.wixstatic.com/media/4a2ebb_32dd91d7db6f4f04855eb5be47c1af07f002.jpg'
    ],
    videos: ['https://video.wixstatic.com/video/4a2ebb_32dd91d7db6f4f04855eb5be47c1af07/1080p/mp4/file.mp4'],
    wixUrl: 'https://www.toneregistry.com/product-page/the-new-real-book-vol-2-in-bb',
    wixProductId: 'c24ce121-7252-2f6b-9463-6f2ac19bd96e',
    seoTitle: 'The New Real Book Vol. 2 in Bb (Indexed ForScore)',
    description: 'The New Real Book Vol. 2 in Bb.',
    features: ['forScore indexed file (.4sc)', 'Opens in forScore only', 'Bb transposition'],
  },
  {
    id: 45,
    name: 'The New Real Book Vol. 3 in Bb',
    slug: 'new-real-book-vol-3-bb',
    price: 9.99,
    category: 'sheet-music',
    image: 'https://static.wixstatic.com/media/4a2ebb_1f58f85330694472ab2aa2366de920f8~mv2.jpg',
    images: [
      'https://static.wixstatic.com/media/4a2ebb_1f58f85330694472ab2aa2366de920f8~mv2.jpg',
      'https://static.wixstatic.com/media/4a2ebb_b8fa2a7c3b8744148ec8537f215e142d~mv2.png'
    ],
    videos: ['https://video.wixstatic.com/video/4a2ebb_32dd91d7db6f4f04855eb5be47c1af07/1080p/mp4/file.mp4'],
    wixUrl: 'https://www.toneregistry.com/product-page/the-new-real-book-vol-3-in-bb-index-forscore',
    wixProductId: '06587e36-8bef-b07d-413e-e2cc34984607',
    seoTitle: 'The New Real Book Vol. 3 in Bb (Indexed ForScore)',
    description: 'The New Real Book Vol. 3 in Bb.',
    features: ['forScore indexed file (.4sc)', 'Opens in forScore only', 'Bb transposition'],
  },

  // ===== SHEET MUSIC - REAL BOOKS IN Eb =====
  {
    id: 46,
    name: 'Real Book Vol. 1 in Eb',
    slug: 'real-book-vol-1-eb',
    price: 9.99,
    category: 'sheet-music',
    image: 'https://static.wixstatic.com/media/4a2ebb_3c74fa3137f847e897ef864ee9426374~mv2.jpg',
    images: [
      'https://static.wixstatic.com/media/4a2ebb_3c74fa3137f847e897ef864ee9426374~mv2.jpg',
      'https://static.wixstatic.com/media/4a2ebb_b8fa2a7c3b8744148ec8537f215e142d~mv2.png',
      'https://static.wixstatic.com/media/4a2ebb_32dd91d7db6f4f04855eb5be47c1af07f002.jpg'
    ],
    videos: ['https://video.wixstatic.com/video/4a2ebb_32dd91d7db6f4f04855eb5be47c1af07/1080p/mp4/file.mp4'],
    wixUrl: 'https://www.toneregistry.com/product-page/real-book-vol-1-in-eb-indexed-forscore',
    wixProductId: '58b19ffa-6d21-010b-2d0b-bf6f878f22f7',
    seoTitle: 'Real Book Vol. 1 in Eb (Indexed ForScore)',
    description: 'Jazz standards in Eb for alto sax players.',
    features: ['forScore indexed file (.4sc)', 'Opens in forScore only', 'Eb transposition'],
  },
  {
    id: 47,
    name: 'Real Book Vol. 2 in Eb',
    slug: 'real-book-vol-2-eb',
    price: 9.99,
    category: 'sheet-music',
    image: 'https://static.wixstatic.com/media/4a2ebb_7e692d767315401ebc434c9326b87f62~mv2.jpg',
    images: [
      'https://static.wixstatic.com/media/4a2ebb_7e692d767315401ebc434c9326b87f62~mv2.jpg',
      'https://static.wixstatic.com/media/4a2ebb_b8fa2a7c3b8744148ec8537f215e142d~mv2.png',
      'https://static.wixstatic.com/media/4a2ebb_32dd91d7db6f4f04855eb5be47c1af07f002.jpg'
    ],
    videos: ['https://video.wixstatic.com/video/4a2ebb_32dd91d7db6f4f04855eb5be47c1af07/1080p/mp4/file.mp4'],
    wixUrl: 'https://www.toneregistry.com/product-page/copy-of-real-book-vol-2-in-eb-indexed-forscore',
    wixProductId: '60ad2197-14e5-0929-c668-fc959a72bb31',
    seoTitle: 'Real Book Vol. 2 in Eb (Indexed ForScore)',
    description: 'Jazz standards Vol. 2 in Eb.',
    features: ['forScore indexed file (.4sc)', 'Opens in forScore only', 'Eb transposition'],
  },
  {
    id: 48,
    name: 'The New Real Book Vol. 1 in Eb',
    slug: 'new-real-book-vol-1-eb',
    price: 9.99,
    category: 'sheet-music',
    image: 'https://static.wixstatic.com/media/4a2ebb_6635cada3964463a8534d42bbd9a313e~mv2.png',
    images: [
      'https://static.wixstatic.com/media/4a2ebb_6635cada3964463a8534d42bbd9a313e~mv2.png',
      'https://static.wixstatic.com/media/4a2ebb_b8fa2a7c3b8744148ec8537f215e142d~mv2.png',
      'https://static.wixstatic.com/media/4a2ebb_32dd91d7db6f4f04855eb5be47c1af07f002.jpg'
    ],
    videos: ['https://video.wixstatic.com/video/4a2ebb_32dd91d7db6f4f04855eb5be47c1af07/1080p/mp4/file.mp4'],
    wixUrl: 'https://www.toneregistry.com/product-page/the-new-real-book-vol-1-in-eb-indexed-forscore',
    wixProductId: '72db4103-1aff-e030-a50f-a2825e345f08',
    seoTitle: 'The New Real Book Vol. 1 in Eb (Indexed ForScore)',
    description: 'The New Real Book in Eb transposition.',
    features: ['forScore indexed file (.4sc)', 'Opens in forScore only', 'Eb transposition'],
  },
  {
    id: 49,
    name: 'The New Real Book Vol. 2 in Eb',
    slug: 'new-real-book-vol-2-eb',
    price: 9.99,
    category: 'sheet-music',
    image: 'https://static.wixstatic.com/media/4a2ebb_e2a6cb4c3bd34b388d66363aa9df54f3~mv2.jpg',
    images: [
      'https://static.wixstatic.com/media/4a2ebb_b8fa2a7c3b8744148ec8537f215e142d~mv2.png',
      'https://static.wixstatic.com/media/4a2ebb_32dd91d7db6f4f04855eb5be47c1af07f002.jpg',
      'https://static.wixstatic.com/media/4a2ebb_e2a6cb4c3bd34b388d66363aa9df54f3~mv2.jpg'
    ],
    videos: ['https://video.wixstatic.com/video/4a2ebb_32dd91d7db6f4f04855eb5be47c1af07/1080p/mp4/file.mp4'],
    wixUrl: 'https://www.toneregistry.com/product-page/the-new-real-book-vol-2-in-eb-indexed-forscore',
    wixProductId: '7b10ab55-c3f5-1595-6e4a-3d036e6027f6',
    seoTitle: 'The New Real Book Vol. 2 in Eb (Indexed ForScore)',
    description: 'The New Real Book Vol. 2 in Eb.',
    features: ['forScore indexed file (.4sc)', 'Opens in forScore only', 'Eb transposition'],
  },
  {
    id: 50,
    name: 'The New Real Book Vol. 3 in Eb',
    slug: 'new-real-book-vol-3-eb',
    price: 9.99,
    category: 'sheet-music',
    image: 'https://static.wixstatic.com/media/4a2ebb_0f8d032957904c7ca619ea7da94a635e~mv2.jpg',
    images: [
      'https://static.wixstatic.com/media/4a2ebb_0f8d032957904c7ca619ea7da94a635e~mv2.jpg',
      'https://static.wixstatic.com/media/4a2ebb_b8fa2a7c3b8744148ec8537f215e142d~mv2.png',
      'https://static.wixstatic.com/media/4a2ebb_32dd91d7db6f4f04855eb5be47c1af07f002.jpg'
    ],
    videos: ['https://video.wixstatic.com/video/4a2ebb_32dd91d7db6f4f04855eb5be47c1af07/1080p/mp4/file.mp4'],
    wixUrl: 'https://www.toneregistry.com/product-page/copy-of-the-new-real-book-vol-3-in-eb-indexed-forscore',
    wixProductId: '9db1b951-cb3e-81c3-474f-64310a750cb6',
    seoTitle: 'The New Real Book Vol. 3 in Eb (Indexed ForScore)',
    description: 'The New Real Book Vol. 3 in Eb.',
    features: ['forScore indexed file (.4sc)', 'Opens in forScore only', 'Eb transposition'],
  },

  // ===== SHEET MUSIC - BASS CLEF =====
  {
    id: 51,
    name: 'Real Book Vol. 1 in Bass Clef',
    slug: 'real-book-vol-1-bass',
    price: 9.99,
    category: 'sheet-music',
    image: 'https://static.wixstatic.com/media/4a2ebb_4993ff910406400b918821278bac7bc9~mv2.png',
    images: [
      'https://static.wixstatic.com/media/4a2ebb_4993ff910406400b918821278bac7bc9~mv2.png',
      'https://static.wixstatic.com/media/4a2ebb_b8fa2a7c3b8744148ec8537f215e142d~mv2.png',
      'https://static.wixstatic.com/media/4a2ebb_32dd91d7db6f4f04855eb5be47c1af07f002.jpg'
    ],
    videos: ['https://video.wixstatic.com/video/4a2ebb_32dd91d7db6f4f04855eb5be47c1af07/1080p/mp4/file.mp4'],
    wixUrl: 'https://www.toneregistry.com/product-page/real-book-vol-1-in-bass-clef-indexed-forscore',
    wixProductId: '1b51ba13-2446-795a-fefd-6a06eae22fb0',
    seoTitle: 'Real Book Vol. 1 in Bass Clef (Indexed ForScore)',
    description: 'Jazz standards in bass clef for trombone and bass players.',
    features: ['forScore indexed file (.4sc)', 'Opens in forScore only', 'Bass clef'],
  },

  // ===== DIGITAL PRODUCTS & ARRANGEMENTS =====
  {
    id: 52,
    name: 'Art in Trumpet (Digital Album)',
    slug: 'art-in-trumpet-album',
    price: 9.99,
    category: 'digital',
    image: 'https://static.wixstatic.com/media/4a2ebb_808ea6fb5829472cbeae22e972656b8c~mv2.jpg',
    images: [
      'https://static.wixstatic.com/media/4a2ebb_b8fa2a7c3b8744148ec8537f215e142d~mv2.png'
    ],
    wixUrl: 'https://www.toneregistry.com/product-page/art-in-trumpet',
    wixProductId: '3edb81b0-f34b-27ce-744c-76a7524ae399',
    seoTitle: 'Art in Trumpet — Digital Album & Arrangement Collection by Isaias Jiménez',
    description: "Inspired by the critically acclaimed album, this collection showcases the trumpet's ability to transcend traditional repertoire and bring new life to some of the most celebrated works ever written.",
    descriptionRich: {
      tagline: 'A collection that redefines the trumpet repertoire.',
      paragraphs: [
        "Inspired by the critically acclaimed album, Art in Trumpet showcases the trumpet's ability to transcend traditional repertoire and bring new life to some of the most celebrated works ever written.",
        "The album features virtuosic trumpet adaptations of masterpieces by composers such as Rimsky-Korsakov, Saint-Saëns, Bartók, Paganini, Debussy, Mendelssohn, and Gershwin — with many of the arrangements created by Isaias himself.",
        "Developed through years of performance experience, these arrangements represent a unique fusion of classical artistry and trumpet virtuosity. Originally written for violin, orchestra, piano, and other instruments, each work has been carefully adapted to preserve the character, technical brilliance, and musical depth of the original compositions while highlighting the expressive possibilities of the trumpet.",
        "Whether you are a professional trumpet player, university student, competition participant, or recital artist, these arrangements offer an opportunity to perform repertoire rarely heard on trumpet. They combine technical challenges, lyrical expression, and audience appeal — making them ideal for recitals, festivals, masterclasses, and concert performances.",
        "Each arrangement has been tested in live performance and refined to balance authenticity with playability, allowing trumpet players to explore repertoire traditionally reserved for the world's greatest violinists and solo instrumentalists.",
      ],
      pullquote: 'Repertoire traditionally reserved for violinists — finally written for the trumpet.',
      keyFeatures: [
        { icon: '🎵', label: 'Chanson Arabe', body: 'Rimsky-Korsakov' },
        { icon: '💀', label: 'Danse Macabre', body: 'Saint-Saëns' },
        { icon: '🇷🇴', label: 'Romanian Folk Dances', body: 'Bartók' },
        { icon: '🎻', label: 'Hora Staccato', body: 'Dinicu-Heifetz' },
        { icon: '♾️', label: 'Moto Perpetuo', body: 'Paganini' },
        { icon: '🌹', label: 'Introduction and Rondo Capriccioso', body: 'Saint-Saëns' },
        { icon: '🌀', label: 'Arabesque No. 1', body: 'Debussy' },
        { icon: '🇪🇸', label: 'Danse Espagnole', body: 'de Falla' },
        { icon: '🎼', label: 'Violin Concerto Op. 64', body: 'Mendelssohn' },
        { icon: '🔔', label: 'La Campanella', body: 'Paganini (Concerto No. 2)' },
        { icon: '🎺', label: 'Rhapsody in Blue', body: 'Gershwin' },
      ],
    },
    features: ['11 trumpet arrangements', 'Inspired by the album', 'Digital download', 'High-quality audio', 'Sheet music available separately'],
  },
  {
    id: 53,
    name: 'Tuning Chart',
    slug: 'tuning-chart',
    price: 1.99,
    category: 'digital',
    image: 'https://static.wixstatic.com/media/4a2ebb_9abba6dd39f94d1cb2bdc683d3c0e779~mv2.png',
    images: [
      'https://static.wixstatic.com/media/4a2ebb_b8fa2a7c3b8744148ec8537f215e142d~mv2.png'
    ],
    wixUrl: 'https://www.toneregistry.com/product-page/tuning-chart',
    wixProductId: '12706874-43e9-30f6-6265-24e6995cfc0d',
    seoTitle: 'Brass Instrument Tuning Chart',
    description: 'Essential tuning reference chart for brass players.',
    features: ['Compact design', 'Easy reference', 'All brass instruments'],
  },
  {
    id: 54,
    name: 'Malagueña Solo Acapella Version',
    slug: 'malaguena-solo',
    price: 14.99,
    category: 'digital',
    image: 'https://static.wixstatic.com/media/4a2ebb_854e0e3b8fc84f348f9015447e9e3dcf~mv2.png',
    images: [
      'https://static.wixstatic.com/media/4a2ebb_b8fa2a7c3b8744148ec8537f215e142d~mv2.png'
    ],
    wixUrl: 'https://www.toneregistry.com/product-page/malague%C3%B1a-solo-acapella-version',
    wixProductId: '994d33ad-017f-6984-8a79-99225e927116',
    seoTitle: 'Malagueña Solo Acapella Version',
    description: "Ernesto Lecuona's 1933 Cuban classic, stripped to the essence. My original a-cappella arrangement for solo trumpet — every flourish, no accompaniment.",
    features: ['PDF score', 'Solo trumpet (a-cappella)', 'My original arrangement'],
  },
  {
    id: 55,
    name: 'Glière French Horn Concerto (Nakariakov)',
    slug: 'gliere-horn-concerto',
    price: 24.99,
    category: 'digital',
    image: 'https://static.wixstatic.com/media/4a2ebb_89dd0ebff6584ac2ba20507c6470b400~mv2.png',
    images: [
      'https://static.wixstatic.com/media/4a2ebb_89dd0ebff6584ac2ba20507c6470b400~mv2.png'
    ],
    wixUrl: 'https://www.toneregistry.com/product-page/glier%C3%A9-french-horn-concerto-as-played-by-sergei-nakariakov',
    wixProductId: 'e0418444-f0c2-3fb5-bd10-82af6d69e99b',
    seoTitle: 'Glière French Horn Concerto as Played by Sergei Nakariakov',
    description: "Reinhold Glière's lush 1951 Horn Concerto in B-flat — his only concerto for a brass instrument and a late-Romantic masterpiece. My original trumpet arrangement, for trumpet and piano.",
    features: ['PDF score', 'Trumpet & piano', 'My original arrangement'],
  },
  {
    id: 56,
    name: 'Espada de La Noche',
    slug: 'espada-de-la-noche',
    price: 24.99,
    category: 'digital',
    image: 'https://static.wixstatic.com/media/4a2ebb_69b0da9bad41421b9664011e799561d6~mv2.png',
    images: [
      'https://static.wixstatic.com/media/4a2ebb_b8fa2a7c3b8744148ec8537f215e142d~mv2.png',
      'https://static.wixstatic.com/media/4a2ebb_64e1cfd30de0431ab0161a09cca0e94cf002.jpg'
    ],
    wixUrl: 'https://www.toneregistry.com/product-page/espada-de-la-noche',
    wixProductId: '0554d96a-b985-d8fb-bbae-f8d4685fc977',
    seoTitle: 'Espada de La Noche – Trumpet Arrangement',
    description: "\"Sword of the Night\" — a dark, cinematic original composition by Isaías Jiménez, built on driving rhythms and dramatic melodic leaps. Written for trumpet and piano.",
    features: ['PDF score', 'Trumpet & piano', 'Original composition'],
  },
  {
    id: 57,
    name: 'Arabesque No. 1',
    slug: 'arabesque-no-1',
    price: 19.99,
    category: 'digital',
    image: 'https://static.wixstatic.com/media/4a2ebb_c9c37c834bb9450a8eb1e55deb6f13cc~mv2.png',
    images: [
      'https://static.wixstatic.com/media/4a2ebb_b8fa2a7c3b8744148ec8537f215e142d~mv2.png'
    ],
    wixUrl: 'https://www.toneregistry.com/product-page/arabesque-no-1-1',
    wixProductId: '98b705f5-3758-2da6-de32-38191273104e',
    seoTitle: 'Arabesque No. 1 – Trumpet Arrangement',
    description: "Claude Debussy's lyrical 1888 piano piece — one of his earliest mature works, full of impressionist colour and floating modal harmony. My original arrangement for trumpet and piano.",
    features: ['PDF score', 'Trumpet & piano', 'My original arrangement'],
  },
  {
    id: 58,
    name: 'The Green Hornet Acapella',
    slug: 'green-hornet-acapella',
    price: 5.99,
    category: 'digital',
    image: 'https://static.wixstatic.com/media/4a2ebb_43be3082ea41439cbbe03cf4fcf38a76~mv2.png',
    images: [
      'https://static.wixstatic.com/media/4a2ebb_b8fa2a7c3b8744148ec8537f215e142d~mv2.png',
      'https://static.wixstatic.com/media/4a2ebb_43be3082ea41439cbbe03cf4fcf38a76~mv2.png'
    ],
    wixUrl: 'https://www.toneregistry.com/product-page/the-green-hornet-acapella',
    wixProductId: '645f4572-6744-92be-3c5b-59a94d10d63d',
    seoTitle: 'The Green Hornet Acapella',
    description: "Rimsky-Korsakov's \"Flight of the Bumblebee\" — re-titled The Green Hornet after the 1936-66 radio/TV theme. My original a-cappella arrangement for solo trumpet.",
    features: ['PDF score', 'Solo trumpet (a-cappella)', 'My original arrangement'],
  },
  {
    id: 59,
    name: 'Danse Macabre',
    slug: 'danse-macabre',
    price: 9.99,
    category: 'digital',
    image: 'https://static.wixstatic.com/media/4a2ebb_ce2091de96b042cbb2211fcfe79b50a1~mv2.png',
    images: [
      'https://static.wixstatic.com/media/4a2ebb_ce2091de96b042cbb2211fcfe79b50a1~mv2.png'
    ],
    wixUrl: 'https://www.toneregistry.com/product-page/danse-macabre-as-recorded-on-art-in-trumpet',
    wixProductId: '8743e060-e3df-6f8e-c351-fbc3413860d2',
    seoTitle: 'Danse Macabre as Recorded on Art in Trumpet',
    description: "Camille Saint-Saëns's 1874 tone poem — Death playing fiddle for skeletons to dance at midnight. Dramatic, theatrical, unforgettable. My original arrangement for trumpet and piano.",
    features: ['PDF score', 'Trumpet & piano', 'My original arrangement'],
  },
  {
    id: 60,
    name: 'Le CouCou',
    slug: 'le-coucou',
    price: 19.99,
    category: 'digital',
    image: 'https://static.wixstatic.com/media/4a2ebb_8fc76f94829942cd96de10de088b2ff3~mv2.png',
    images: [
      'https://static.wixstatic.com/media/4a2ebb_b8fa2a7c3b8744148ec8537f215e142d~mv2.png'
    ],
    wixUrl: 'https://www.toneregistry.com/product-page/le-coucou',
    wixProductId: 'd959174a-7e6e-3892-cb3d-e486cfb2b1d2',
    seoTitle: 'Le CouCou – Trumpet Arrangement',
    description: "Louis-Claude Daquin's 1735 Baroque keyboard miniature — the most charming musical cuckoo ever written. My original arrangement for trumpet and piano.",
    features: ['PDF score', 'Trumpet & piano', 'My original arrangement'],
  },
  {
    id: 61,
    name: "I Can't Get Started (Bunny Berigan)",
    slug: 'i-cant-get-started',
    price: 29.99,
    category: 'digital',
    image: 'https://static.wixstatic.com/media/4a2ebb_c2ae2b5920f1459cb7c057947ff0006c~mv2.png',
    wixUrl: 'https://www.toneregistry.com/product-page/i-can-t-get-started-as-played-by-bunny-barrigan',
    seoTitle: "I Can't Get Started as played by Bunny Berigan",
    description: "Vernon Duke & Ira Gershwin's 1936 jazz standard — immortalised by Bunny Berigan's iconic 1937 trumpet recording. My original arrangement for trumpet and piano.",
    features: ['PDF score', 'Trumpet & piano', 'My original arrangement'],
  },
  {
    id: 62,
    name: 'Blue Rondo a la Turk (Tine Helseth)',
    slug: 'blue-rondo-a-la-turk',
    price: 19.99,
    category: 'digital',
    image: 'https://static.wixstatic.com/media/4a2ebb_b2524eb3d8d04bf88fc1944e06448686~mv2.png',
    wixUrl: 'https://www.toneregistry.com/product-page/blue-rondo-a-la-turk-as-played-by-tine-helseth',
    seoTitle: 'Blue Rondo a la Turk as Played by Tine Helseth',
    description: "Dave Brubeck's 1959 jazz landmark from *Time Out* — built on a tricky 9/8 Turkish folk rhythm (2+2+2+3) that breaks into swinging 4/4 for the solos. My original arrangement for trumpet and piano.",
    features: ['PDF score', 'Trumpet & piano', 'My original arrangement'],
  },
  {
    id: 63,
    name: 'Oblivion (Tine Helseth)',
    slug: 'oblivion',
    price: 19.99,
    category: 'digital',
    image: 'https://static.wixstatic.com/media/4a2ebb_99f32594e5474dc7942f5367f68e4b57~mv2.png',
    wixUrl: 'https://www.toneregistry.com/product-page/oblivion-as-played-by-tine-helseth',
    seoTitle: 'Oblivion as Played by Tine Helseth',
    description: "Astor Piazzolla's haunting 1982 milonga — written for the film *Henry IV*, now one of the most beloved tangos of the 20th century. My original arrangement for trumpet and piano.",
    features: ['PDF score', 'Trumpet & piano', 'My original arrangement'],
  },
  {
    id: 64,
    name: 'Libertango (Tine Helseth)',
    slug: 'libertango',
    price: 19.99,
    category: 'digital',
    image: 'https://static.wixstatic.com/media/4a2ebb_11dca2f5d6484b7c8d4a26b61dbbbcd7~mv2.png',
    wixUrl: 'https://www.toneregistry.com/product-page/libertango-as-played-by-tine-helseth',
    seoTitle: 'Libertango as Played by Tine Helseth',
    description: "Astor Piazzolla's 1974 *nuevo tango* anthem — the moment Argentine tango fused with jazz, rock, and contemporary classical. My original arrangement for trumpet and piano.",
    features: ['PDF score', 'Trumpet & piano', 'My original arrangement'],
  },
  {
    id: 65,
    name: 'Caprice 24 (Sergei Nakariakov)',
    slug: 'caprice-24',
    price: 19.99,
    category: 'digital',
    image: 'https://static.wixstatic.com/media/4a2ebb_2a9d09b515f748ebaf792bd5a994a6b4~mv2.png',
    wixUrl: 'https://www.toneregistry.com/product-page/caprice-24',
    seoTitle: 'Caprice 24 as Recorded by Sergei Nakariakov',
    description: "Paganini's most famous solo work — a theme with eleven variations that has been the proving ground for virtuosos since 1817. My original arrangement for trumpet and piano.",
    features: ['PDF score', 'Trumpet & piano', 'My original arrangement'],
  },
  {
    id: 66,
    name: "Les Chemins de L'Amour",
    slug: 'les-chemins-de-lamour',
    price: 19.99,
    category: 'digital',
    image: 'https://static.wixstatic.com/media/4a2ebb_ac37cb77d0834f7587644ee6912a5439~mv2.png',
    wixUrl: 'https://www.toneregistry.com/product-page/les-chemins-de-l-amoure',
    seoTitle: "Les Chemins de L'Amour - Trumpet Arrangement",
    description: "Francis Poulenc's tender 1940 art song — \"The Paths of Love\" — a bittersweet waltz that became one of the most beloved French mélodies of the 20th century. My original arrangement for trumpet and piano.",
    features: ['PDF score', 'Trumpet & piano', 'My original arrangement'],
  },
  {
    id: 67,
    name: 'Pavane Pour Une Infante Defunte (Nakariakov)',
    slug: 'pavane-pour-une-infante-defunte',
    price: 24.99,
    category: 'digital',
    image: 'https://static.wixstatic.com/media/4a2ebb_74b4c3c994124c4baa95b6b7119578f0~mv2.png',
    wixUrl: 'https://www.toneregistry.com/product-page/pavane-pour-une-infante-defunte',
    seoTitle: 'Pavane Pour Une Infante Defunte as Recorded by Sergei Nakariakov',
    description: "Maurice Ravel's 1899 \"Pavane for a Dead Princess\" — a slow, modal processional evoking a Spanish court dance from a forgotten era. My original arrangement for trumpet and piano.",
    features: ['PDF score', 'Trumpet & piano', 'My original arrangement'],
  },
  {
    id: 68,
    name: 'The Green Hornet Full Big Band',
    slug: 'green-hornet-big-band',
    price: 49.99,
    category: 'digital',
    image: 'https://static.wixstatic.com/media/4a2ebb_43be3082ea41439cbbe03cf4fcf38a76~mv2.png',
    wixUrl: 'https://www.toneregistry.com/product-page/the-green-hornet-full-big-band',
    seoTitle: 'The Green Hornet Full Big Band Arrangement',
    description: 'Full big band score and parts for The Green Hornet (Flight of the Bumblebee). Trumpet, sax, trombone, and rhythm section parts included. Performed by the LAJO (Latin American Jazz Orchestra) — high-energy concert closer.',
    features: ['Full score', 'Big band parts', 'Complete arrangement'],
  },
  {
    id: 69,
    name: 'Hora Staccato',
    slug: 'hora-staccato',
    price: 20.99,
    category: 'digital',
    image: 'https://static.wixstatic.com/media/4a2ebb_c91692d6c0a2445ca57ab271002d83b1~mv2.png',
    wixUrl: 'https://www.toneregistry.com/product-page/hora-staccato',
    seoTitle: 'Hora Staccato as Recorded on Art in Trumpet',
    description: "Grigoraș Dinicu's Romanian violin showpiece (1906), made famous worldwide by Jascha Heifetz. A pyrotechnic feat of speed and articulation. My original arrangement for trumpet and piano.",
    features: ['PDF score', 'Trumpet & piano', 'My original arrangement'],
  },
  {
    id: 70,
    name: 'Danse Espagnol',
    slug: 'danse-espagnol',
    price: 24.99,
    category: 'digital',
    image: 'https://static.wixstatic.com/media/4a2ebb_974b87a003574ab699c5977082781116~mv2.png',
    wixUrl: 'https://www.toneregistry.com/product-page/danse-espagnol',
    seoTitle: 'Danse Espagnol as Recorded on Art in Trumpet',
    description: "Manuel de Falla's fiery Spanish dance from *La vida breve* (1905) — flamenco passion translated to the concert stage. My original arrangement for trumpet and piano.",
    features: ['PDF score', 'Trumpet & piano', 'My original arrangement'],
  },
  {
    id: 71,
    name: 'Meditation (Sergei Nakariakov)',
    slug: 'meditation',
    price: 24.99,
    category: 'digital',
    image: 'https://static.wixstatic.com/media/4a2ebb_e30b953c7af449db9413ba8bfe803424~mv2.png',
    wixUrl: 'https://www.toneregistry.com/product-page/meditation',
    seoTitle: 'Meditation as Recorded by Sergei Nakariakov',
    description: "Jules Massenet's \"Méditation\" from his 1894 opera *Thaïs* — a serene symphonic intermezzo, originally for solo violin and orchestra. My original arrangement for trumpet and piano.",
    features: ['PDF score', 'Trumpet & piano', 'My original arrangement'],
  },
  {
    id: 72,
    name: 'Chanson Arabe',
    slug: 'chanson-arabe',
    price: 9.99,
    category: 'digital',
    image: 'https://static.wixstatic.com/media/4a2ebb_85bd226a641c4b8ca987c625b5873b6f~mv2.png',
    wixUrl: 'https://www.toneregistry.com/product-page/chanson-arabe',
    seoTitle: 'Chanson Arabe as Recorded on Art in Trumpet',
    description: "From Rimsky-Korsakov's *Scheherazade* (1888) — an exotic, Arabian-style melody full of expressive phrasing. My original arrangement for trumpet and piano.",
    features: ['PDF score', 'Trumpet & piano', 'My original arrangement'],
  },
  {
    id: 73,
    name: 'Campanella No. 2 Op. 7',
    slug: 'campanella',
    price: 24.99,
    category: 'digital',
    image: 'https://static.wixstatic.com/media/4a2ebb_1b30cf11ca15435b90b4979c18c11040~mv2.png',
    wixUrl: 'https://www.toneregistry.com/product-page/campanella-by-paganini',
    seoTitle: 'Campanella No. 2 Op. 7 as Recorded on Art in Trumpet',
    description: "Paganini's dazzling \"Little Bell\" — Caprice No. 2 Op. 7, the showpiece every virtuoso wants to play. My original arrangement for trumpet and piano.",
    features: ['PDF score', 'Trumpet & piano', 'My original arrangement'],
  },
  {
    id: 74,
    name: 'Le Plus que Lente (Nakariakov)',
    slug: 'le-plus-que-lente',
    price: 24.99,
    category: 'digital',
    image: 'https://static.wixstatic.com/media/4a2ebb_1d1efb7872224a11a1532e429898a3cf~mv2.png',
    wixUrl: 'https://www.toneregistry.com/product-page/le-plus-que-lente',
    seoTitle: 'Le Plus que Lente as Recorded by Sergei Nakariakov',
    description: "Claude Debussy's 1910 \"More Than Slow\" — a wickedly elegant Parisian waltz, his own send-up of café-concert music. My original arrangement for trumpet and piano.",
    features: ['PDF score', 'Trumpet & piano', 'My original arrangement'],
  },
  {
    id: 75,
    name: 'Romanian Folk Dances',
    slug: 'romanian-folk-dances',
    price: 24.99,
    category: 'digital',
    image: 'https://static.wixstatic.com/media/4a2ebb_9b4c51aa49464dc7bc5d79720775ab3e~mv2.png',
    wixUrl: 'https://www.toneregistry.com/product-page/romanian-folk-dances',
    seoTitle: 'Romanian Folk Dances as Recorded on Art in Trumpet',
    description: "Béla Bartók's 1915 set of six Romanian folk dances — rooted in Transylvanian peasant music, irresistibly rhythmic and tuneful. My original arrangement for trumpet and piano.",
    features: ['PDF score', 'Trumpet & piano', 'My original arrangement'],
  },
  {
    id: 76,
    name: 'Mendelssohn Violin Concerto (Rafael Méndez)',
    slug: 'mendelssohn-violin-concerto',
    price: 24.99,
    category: 'digital',
    image: 'https://static.wixstatic.com/media/4a2ebb_5100ee9b4ce74522961153550c453e28~mv2.png',
    wixUrl: 'https://www.toneregistry.com/product-page/mendelssohn-violin-concerto',
    seoTitle: 'Mendelssohn Violin Concerto as Recorded by Rafael Méndez',
    description: "Felix Mendelssohn's 1844 Violin Concerto in E minor, Op. 64 — one of the most beloved Romantic concertos ever written. My original trumpet adaptation, for trumpet and piano.",
    features: ['PDF score', 'Trumpet & piano', 'My original arrangement'],
  },
];

export const featuredProducts = products.filter(function(p) { return p.featured; });
